webpackJsonp([1],{

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "52Ql":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7JYK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e4cd6ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("52Ql")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2690a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("NZMO")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-ba2690a0"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd022a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("uDJ7")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36923708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("eJtY")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b6df172","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("7JYK")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    isIframe: function isIframe() {
      return this.videoURL.search('partnerdomain') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b9dc297","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_vm._e(),_vm._v(" "),(_vm.isIframe)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container",attrs:{"id":"ocplayer1"}},[_c('iframe',{attrs:{"id":"video","width":"950","height":"534","src":_vm.videoURL,"frameborder":"0","scrolling":"no","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("OOSv")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-308c83a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("SCeq")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/document.js


var _ref;

/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "FIG Yearbook 2021",
  "shortTitle": "",
  "description": "",
  "width": 620,
  "height": 877,
  "currentLanguage": "EN",
  "languages": [],
  "basePath": "/2021",
  // "basePath": "",
  "companyLogo": "1-logo-1.png",
  "publishURL": "https://yearbook.gymnastics.sport/2021/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": '/2021/static/_content/fig-2021.pdf',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScaleC 1-logo\" style=\"top:334px; left:-83px;\" src=\"/2021/static/_content/1-logo-1.png\">\n        <img class=\"halfScale 1-title-1\" style=\"top:672px;right:-379px;\" src=\"/2021/static/_content/1-title-1.png\">\n        <img class=\"halfScale 1-title-2\" style=\"top:806px;left:361px;\" src=\"/2021/static/_content/1-title-2.png\">\n\n        <div class=\"addContentLink\" style=\"top:417px;left:188px;width:88px;height:12px;\">\n          <a href=\"https://gymnastics.sport/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"1-logo\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.8)\n          .fromTo(cOf(\"1-title-1\"), 1, {opacity:0, x:-120}, {opacity:1, x:0, ease: Power2.easeOut}, 1.3)\n          .fromTo(cOf(\"1-title-2\"), 1.1, {opacity:0, x:-80}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: flashContentLinksThreeTimes}, 1.6)\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          removeContentLinks();\n      }\n      ",
    "searchText": "2021 Yearbook"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:815px;left:24px;width:287px;height:15px;\">\n        <a href=\"https://sports-topics.jp.fujitsu.com/en/solutions/judging-support-system/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:830px;left:24px;width:155px;height:15px;\">\n        <a href=\"https://sports-topics.jp.fujitsu.com/en/solutions/judging-support-system/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top:228px;left:62px;width:323px;height:12px;\" onclick=\"Publish.goToPage(4)\"></div>\n\n        <div class=\"abs\" style=\"top:260px;left:62px;width:323px;height:45px;\">\n          <div class=\"addContentLink\" style=\"top:0px;left:0px;width:100%;height:18px;\" onclick=\"Publish.goToPage(6)\"></div>\n          <div class=\"addContentLink\" style=\"top:20px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(8)\"></div>\n          <div class=\"addContentLink\" style=\"top:32px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(10)\"></div>\n        </div>\n\n        <div class=\"abs\" style=\"top:326px;left:62px;width:323px;height:45px;\">\n          <div class=\"addContentLink\" style=\"top:0px;left:0px;width:100%;height:18px;\" onclick=\"Publish.goToPage(24)\"></div>\n          <div class=\"addContentLink\" style=\"top:20px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(26)\"></div>\n          <div class=\"addContentLink\" style=\"top:32px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(30)\"></div>\n        </div>\n\n        <div class=\"abs\" style=\"top:390px;left:62px;width:323px;height:45px;\">\n          <div class=\"addContentLink\" style=\"top:0px;left:0px;width:100%;height:18px;\" onclick=\"Publish.goToPage(42)\"></div>\n          <div class=\"addContentLink\" style=\"top:20px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(44)\"></div>\n          <div class=\"addContentLink\" style=\"top:32px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(50)\"></div>\n        </div>\n\n        <div class=\"abs\" style=\"top:456px;left:62px;width:323px;height:77px;\">\n          <div class=\"addContentLink\" style=\"top:0px;left:0px;width:100%;height:18px;\" onclick=\"Publish.goToPage(58)\"></div>\n          <div class=\"addContentLink\" style=\"top:20px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(60)\"></div>\n          <div class=\"addContentLink\" style=\"top:32px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(64)\"></div>\n          <div class=\"addContentLink\" style=\"top:44px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(68)\"></div>\n          <div class=\"addContentLink\" style=\"top:56px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(72)\"></div>\n          <div class=\"addContentLink\" style=\"top:68px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(76)\"></div>\n        </div>\n\n        <div class=\"abs\" style=\"top:553px;left:62px;width:323px;height:121px;\">\n          <div class=\"addContentLink\" style=\"top:0px;left:0px;width:100%;height:18px;\" onclick=\"Publish.goToPage(80)\"></div>\n          <div class=\"addContentLink\" style=\"top:20px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(82)\"></div>\n          <div class=\"addContentLink\" style=\"top:32px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(84)\"></div>\n          <div class=\"addContentLink\" style=\"top:44px;left:0px;width:100%;height:11px;\" onclick=\"Publish.goToPage(86)\"></div>\n          <div class=\"addContentLink\" style=\"top:55px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(90)\"></div>\n          <div class=\"addContentLink\" style=\"top:67px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(92)\"></div>\n          <div class=\"addContentLink\" style=\"top:79px;left:0px;width:100%;height:11px;\" onclick=\"Publish.goToPage(98)\"></div>\n          <div class=\"addContentLink\" style=\"top:90px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(102)\"></div>\n          <div class=\"addContentLink\" style=\"top:102px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(104)\"></div>\n          <div class=\"addContentLink\" style=\"top:114px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(108)\"></div>\n        </div>\n\n        <div class=\"abs\" style=\"top:695px;left:62px;width:323px;height:45px;\">\n          <div class=\"addContentLink\" style=\"top:0px;left:0px;width:100%;height:18px;\" onclick=\"Publish.goToPage(114)\"></div>\n          <div class=\"addContentLink\" style=\"top:20px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(116)\"></div>\n          <div class=\"addContentLink\" style=\"top:32px;left:0px;width:100%;height:12px;\" onclick=\"Publish.goToPage(120)\"></div>\n        </div>\n\n        <div class=\"abs\" style=\"top:758px;left:62px;width:323px;height:20px;\">\n          <div class=\"addContentLink\" style=\"top:0px;left:0px;width:100%;height:18px;\" onclick=\"Publish.goToPage(122)\"></div>\n        </div>\n\n        <div class=\"abs\" style=\"top:795px;left:62px;width:323px;height:19px;\">\n          <div class=\"addContentLink\" style=\"top:0px;left:0px;width:100%;height:18px;\" onclick=\"Publish.goToPage(129)\"></div>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:595px;left:436px;width:88px;height:12px;\">\n          <a href=\"https://gymnastics.sport/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "CONTENTS INTRODUCTION President’s Foreword						  4  HIGHLIGHTS OF 2021					  6  Elections						 Tokyo 2020						  8 10  CONGRESS							 24 Antalya 2021 Elections  26 30  SPORT								 42 World Championships					 World Cups						  44 50  MEDIA & MARKETING						 58 Fan Engagement and Social Media			 TV							 Media Operations					 Marketing and Sponsors				 Audience						  60 64 68 72 76  INSTITUTIONAL						  80  Governance						 Measures during Pandemic				 Safeguarding						 Gender Equality					 Development and Education				 Medical/Anti-Doping					 Technology						 Apparatus						 Financial						  82 84 86 90 92 98 102 104 108  INSIDE THE FIG						  114  Structure of the Organisation				 Athletes’ Commission				  116 120  OUTLOOK 2022-2024				  122  USEFUL LINKS  129  Fédération Internationale de Gymnastique, Av. de la Gare 12 A, 1001 Lausanne, Switzerland Tel +41 (0)21 321 55 10 www.gymnastics.sport This publication may not be reproduced, even in part, in any form, without the written permission of the FIG. Production: Touchline Photography: FIG/Volker Minkus, FIG/Jean-Pierre Limery Printed by Pureprint.  The FIG Yearbook is printed at a carbon-neutral printer, on a 100% recycled and carbonbalanced paper stock.  FIG YEARBOOK 2021  03"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Introduction  PRESIDENT’S FOREWORD Morinari Watanabe FIG President IOC member  I  am pleased to present to you the first-ever FIG Yearbook. This Yearbook looks back on the major Gymnastics events that marked 2021 and gives an overview of the progress in the main areas of the life of the international federation. 2021 was a special year. After the darkness of 2020, when the sport was at a standstill, 2021 was the year of a gradual resumption of activities. After 12 months of waiting, and despite challenging conditions, the Tokyo Olympic Games finally took place and Gymnastics once again lit up the Games. But performances were not all that mattered. The focus was also on moving moments when athletes cared for their competitors and showed respect for each other. These kinds of scenes happened in previous Olympics too, but had never become such prominent highlights of the Games, and never was the sense of friendship and solidarity so valued. While the pandemic continued to affect our daily lives, the Gymnastics community was able to enjoy the pleasure of meeting again on the occasion of the World Championships of Aerobic Gymnastics in Baku, Azerbaijan, and of Acrobatics in Geneva, Switzerland – two Championships that had been postponed by one year. For the first time, the Artistic and Rhythmic World Championships were held back-to-back in the same city: Kitakyushu, Japan. This is an avenue to explore – to hold the World Championships in all our disciplines  04  FIG YEARBOOK 2021  in the same city back-to-back. It would be like a Gymnastics Olympics. This would give more cumulative value to all our World Championships and attract the interest of sponsors. After the Congress, Gymnastics went back to Baku, for the Trampoline World Championships. The pandemic has disrupted our daily lives, and these disruptions have forced us to think differently. Travel restrictions have shown us that digitisation is no longer an option, but rather a necessity. The FIG has already taken this path by developing the Judging Support System with Fujitsu, and is also doing so in education. The new elearning platform enables us to extend the scope of the Academies. As we saw with the Tokyo Games, the public’s expectations of the sporting world are changing. The public expects sport to be no longer just pure entertainment, but rather a driving force in society. As an international organisation, the FIG must contribute to the promotion of the United Nations’ Sustainable Development Goals (SDGs). Gender equality, Health and Peace are three SDGs in which Gymnastics has a role to play. The public also expects the highest standards from international federations when it comes to good governance and safeguarding, especially protecting the youngest athletes. And we can say that the FIG has made big strides in this regard in recent years. All these aims must guide our actions this year and in the years to come. Before leaving you to explore this first Yearbook, allow me to thank all those who have shown their confidence in me by electing me once again as FIG President. It is a great honour and I will do everything to be worthy of it."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <a onclick=\"Publish.openVideo('https://www.olympicchannel.com/video/syndicated/detail/gold-in-men-s-all-around-tokyo-2020-highlights?partner_name=www.gymnastics.sport&partnerdomain=www.gymnastics.sport')\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:318px;top:707px\" src=\"/2021/static/_content/white-play.png\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          var player = new OLYMPIC_CHANNEL.Syndicated(\"gold-in-mens-all-around-tokyo-2020-highlights\", {dimensions: [950,534], id: \"ocplayer1\"})\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Highlights  of 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "        \n        <div class=\"addContentLink\" style=\"top:606px;left:74px;width:64px;height:12px;\">\n          <a href=\"https://www.gymnastics.sport/site/news/displaynews.php?urlNews=3380191\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Highlights of 2021  Elections  FIG PRESIDENT EARNS RE-ELECTION The re-election of Morinari Watanabe as FIG President was a highlight of the 83rd FIG Congress in November 2021.  08  FIG YEARBOOK 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:803px;left:466px;width:19px;height:12px;\" onclick=\"Publish.goToPage(26)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Elections  Highlights of 2021  M  orinari Watanabe was re-elected as FIG President on 6 November 2021, earning a mandate for a second term at the helm of Gymnastics’ world governing body. President Watanabe earned his fresh mandate at the FIG Congress in Antalya, Turkey. It will run from 1 January 2022 until 31 December 2024 and the same applies to all of the officials who gained election at the Congress. This was after the Congress ratified the decision of the FIG Executive Committee to reduce the next terms of office for all positions to three years instead of four, in order to correspond with the Olympic cycle leading up to the Paris 2024 Games. For more details, see the Congress section on p26.  FIG YEARBOOK 2021  09"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Highlights of 2021  Tokyo 2020  NEW STARS ON OLYMPIC STAGE The Tokyo Games featured a wave of firsts as new champions emerged from far and wide and Simone Biles delivered an important message about mental health.  USA’s Sunisa Lee at Tokyo 2020  10  FIG YEARBOOK 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n        <a onclick=\"Publish.openVideo('https://www.olympicchannel.com/video/syndicated/detail/gold-in-women-s-all-around-tokyo-2020-highlights?partner_name=yearbook.gymnastics.sport&partnerdomain=yearbook.gymnastics.sport')\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:218px;top:107px\" src=\"/2021/static/_content/white-play.png\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Tokyo 2020  Highlights of 2021  T  hey were an Olympic Games staged a year later than originally planned. Yet the Games of the XXXII Olympiad nonetheless flipped and spun their way into the hearts of millions and nowhere more so than at the Ariake Gymnastics Centre. There, between 24 July and 8 August, 324 gymnasts competed for 18 sets of medals – with a record 20 nations earning a place on the podium to underline Gymnastics’ ever more global appeal. At 19, Hashimoto Daiki (JPN) became the youngest man to win Olympic All-Around gold, following in the footsteps of the legendary Uchimura Kohei to keep the men’s crown in Japan. Watching Uchimura claim his second All-Around title five years earlier in Rio, Hashimoto had thought he would never reach such a level yet the teenager surpassed expectations, with golden results. Sunisa Lee (USA), for her part, rose to the unique challenges and expectations of being the first US Olympian from the Hmong community as well as one of the de-facto leaders of her team following the withdrawal of Simone Biles. The 18-year-old shouldered the immense pressure of representing community and country with a poise beyond her years. In the All-Around final, she performed her routines with panache – including a Floor Exercise routine reworked that very morning to protect a sore ankle – to become the fifth consecutive US gymnast to capture the women’s Individual All-Around gold.  FIG YEARBOOK 2021  11"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Highlights of 2021  12  FIG YEARBOOK 2021  Tokyo 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Tokyo 2020  SIMONE BILES SHINES LIGHT ON MENTAL HEALTH Expected to write a golden epilogue to her success at Rio 2016, Simone Biles (USA) had a shorter Olympics than anticipated – but her Games were no less meaningful. Biles’s withdrawal from the women’s Team final and all but one of the Individual finals was a shock, yet surprise soon gave way to concern and understanding as she spoke frankly about her mentalhealth struggles. The need to “call it” when overwhelming pressure met physically risky Gymnastics skills resonated with gymnasts and non-athletes around the world, and the US superstar’s return to take bronze on Balance Beam on the final day of Artistic Gymnastics competition was celebrated as if it were gold.  Highlights of 2021  The need to 'call it' resonated with gymnasts and non-athletes around the world.  ROC PREVAIL IN TEAM COMPETITIONS In the Team events, ROC gymnasts claimed gold in both the men’s and women’s finals – a first for the women in the post-Soviet era and only the second for the men, 25 years after their only previous Team victory at Atlanta 1996. Men’s gold was due in part to the herculean efforts of Nikita Nagornyy and Artur Dalaloyan, the latter competing on an Achilles tendon torn less than four months earlier. Twenty-four hours later, Angelina Melnikova, the only member of the team who also competed in Rio, led the ROC women to their title, overcoming the challenge from defending champions USA and bronze medallists Great Britain, who stood on the podium for the first time since finishing third in 1928.  Left USA's Simone Biles Above Team silver for Japan’s Kaya Kazuma, Tanigawa Wataru and Kitazono Takeru  FIG YEARBOOK 2021  13"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <a onclick=\"Publish.openVideo('https://www.olympicchannel.com/video/syndicated/detail/gold-in-individual-rhythmic-gymnastics-tokyo-2020-highlights?partner_name=www.gymnastics.sport&partnerdomain=www.gymnastics.sport')\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:297px;top:211px\" src=\"/2021/static/_content/white-play.png\">\n        </a>\n\n        <h1 id=\"14-no1\" class=\"abs merriweather-bold 14-no\" style=\"left: 474px; top: 609px; font-size: 2em; font-weight:300; margin:0; color:#e73b1f; padding:0; margin:0;\"  data-number='{\"to\": 8}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim.fromTo(cOf(\"14-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"14-no\")[0]);}}, 1)\n        }\n\n        function onPageLeave() {\n          pg14Anim.stop();\n          resetNumbers(\"14-no\")\n        }\n      ",
    "searchText": "Highlights of 2021  Tokyo 2020  HISTORIC GOLDS FOR ISRAEL, BELGIUM, BRAZIL The history came thick and fast – not least for Israel. Artem Dolgopyat won their first Olympic gold medal in Gymnastics, only the country’s second Olympic title, on men’s Floor Exercise before Linoy Ashram took the first Olympic gold by an Israeli woman, ending 20 years of Russian dominance in Rhythmic Gymnastics. There was also a first gold for Belgium from two-time World Uneven Bars champion Nina Derwael, and Brazil’s first gold in Women’s Artistic Gymnastics as Rebeca Andrade returned in the shape of her life following a series of injuries to triumph on Vault. Additionally, medals from Lee Chih-Kai (TPE) on Pommel Horse, Artur Davtyan (ARM) on Vault, Ferhat Arican (TUR) on Parallel Bars, Yeo  14  FIG YEARBOOK 2021  Seo-jeong (KOR) on women’s Vault and Murakami Mai (JPN) on women’s Floor Exercise represented historic firsts for their countries. With silver on Floor at her fourth Olympics, Vanessa Ferrari (ITA), the fourth-place finisher on the apparatus at both London 2012 and Rio 2016, taught the Gymnastics world a lesson in perseverance. Ferrari’s silver was only the second Olympic medal in 50 years taken by a woman over 30, as well as the second medal for an Italian female, coming 93 years after Italy’s Team silver at the 1928 Games in Amsterdam – the first Olympics with a women’s Gymnastics competition.  WHITLOCK BUCKS TREND, CHUSOVITINA BOWS OUT The Olympics began with the untimely exits of many of its defending champions, including Uchimura Kohei  8 Uzbekistan's Oksana Chusovitina, 46, participated in her record eighth Olympic Games"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Tokyo 2020  Highlights of 2021    Whitlock's lights-out performance set the standard too high for anyone else to match.  (JPN), Epke Zonderland (NED), Yang Hak-seon (KOR) and Sanne Wevers (NED). Yet Max Whitlock (GBR), the two-time Olympic champion from Rio, made it to the finals on his best apparatus, Pommel Horse. If his fifth place in qualification raised questions about his readiness to defend his title, the 28-year-old put the doubts to rest with a stellar routine. The first to go in the final, Whitlock gave a lights-out performance  which set the standard too high for anyone else to match. He captured his third Olympic title and sixth medal overall, placing him in the ranks of Britain’s greatest Olympians. It was not just medallists who illuminated the Artistic Gymnastics competition. At 46, Oksana Chusovitina (UZB) competed at her record eighth Olympic Games when taking part in the qualification for the women’s Vault final.  Left Brazil’s Rebeca Andrade and Israel’s Linoy Ashram at Tokyo 2020 Above Britain's Max Whitlock performs his winning routine  FIG YEARBOOK 2021  15"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Highlights of 2021  16  FIG YEARBOOK 2021  Tokyo 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Tokyo 2020  In an arena without spectators, she made an emotional farewell as her fellow gymnasts and the judges rose to salute her on the completion of her final vaults.  ZHU, LITVINOVICH BOUND TO NEW HEIGHTS Even in the presence of the reigning Olympic champions in Trampoline Gymnastics, newcomers Ivan Litvinovich (BLR) and Zhu Xueying (CHN) proved too strong to be denied. Litvinovich’s gold in the men’s competition kept the crown  in Belarus, five years after Uladzislau Hancharou, fourth this time, had prevailed in Rio. With a second straight silver, London 2012 champion Dong Dong (CHN) became the only Trampoline gymnast to have won four Olympic medals as he bowed out of the Games. Zhu, whose victory in the women’s final came after a close-fought contest with compatriot Liu Lingling, became the first Youth Olympic champion to graduate to senior gold in Trampoline Gymnastics. With bronze, Bryony Page (GBR) stood on the podium once more, five years after a groundbreaking silver in Rio.  Highlights of 2021  Left China's Zhu Xueying Below China's Dong Dong (2nd), Belarus' Ivan Litvinovich (1st) and New Zealand's Dylan Schmidt (3rd)  FIG YEARBOOK 2021  17"
  }], [(_ref = {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": ""
  }, defineProperty_default()(_ref, "content", "\n        <a onclick=\"Publish.openVideo('https://www.olympicchannel.com/video/syndicated/detail/gold-in-group-rhythmic-gymnastics-tokyo-2020-highlights?partner_name=www.gymnastics.sport&partnerdomain=www.gymnastics.sport')\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:205px;top:301px\" src=\"/2021/static/_content/white-play.png\">\n        </a>\n\n        <div class=\"addContentLink\" style=\"top:640px;left:481px;width:59px;height:12px;\">\n          <a href=\"https://live.fig-gymnastics.com/medals-prev.php?idevent=15571\" target=\"_blank\"></a>\n        </div>\n\n        <h1 id=\"18-no1\" class=\"abs merriweather-bold 18-no\" style=\"left: 53px; top: 730px; font-size: 2em; font-weight:300; margin:0; color:#e73b1f; padding:0; margin:0;\"  data-number='{\"to\": 18}' ></h1>\n      "), defineProperty_default()(_ref, "script", "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim.fromTo(cOf(\"18-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"18-no\")[0]);}}, 1)\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1200);\n        }\n\n        function onPageLeave() {\n          pg18Anim.stop();\n          resetNumbers(\"18-no\")\n          removeContentLinks();\n        }\n      "), defineProperty_default()(_ref, "searchText", "Highlights of 2021  Tokyo 2020  Right Bulgaria’s women en route to Rhythmic Group gold  “    The Bulgarian Rhythmic group helped end a streak of dominance by ROC athletes dating back to 2000.  18 sets of Gymnastics medals won in Tokyo  18  FIG YEARBOOK 2021  ASHRAM, BULGARIA END ROC RUN  CHINA TOP MEDAL TABLE  Linoy Ashram (ISR) and the Bulgarian group triumphed in Rhythmic Gymnastics to end a streak of dominance by ROC athletes dating back to 2000. Neither title came easily and a mistake in Ashram’s final routine led to a cliffhanger finish before she was confirmed as the discipline’s first non-Russian Individual Olympic champion since 1996. Dina Averina (ROC) and the ROC group each took silver, while bronzes for Alina Harnasko (BLR) and the Italian group marked a return to the podium for both their nations in Rhythmic for the first time since London 2012.  The People’s Republic of China topped the overall Gymnastics medal table with four gold, five silver, and two bronze medals – including golds on Balance Beam from Guan Chenchen, Still Rings from Liu Yang, and Parallel Bars from Zou Jingyuan. ROC took second place, with their 10 medals including the men’s and women’s Team titles in Artistic Gymnastics. The United States, with golds from Lee in the Artistic All-Around and Jade Carey on women’s Floor, ranked third."), _ref)], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Tokyo 2020  Highlights of 2021  Left China’s Liu Yang (right) is congratulated on Still Rings gold  FIG YEARBOOK 2021  19"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"halfScaleC 20-usa\" style=\"top:370px; left:91px;\" src=\"/2021/static/_content/20-usa-gold.png\">\n      <img class=\"halfScaleC 20-usa\" style=\"top:370px; left:113px;\" src=\"/2021/static/_content/20-usa-silver.png\">\n      <img class=\"halfScaleC 20-usa\" style=\"top:370px; left:135px;\" src=\"/2021/static/_content/20-usa-bronze.png\">\n\n      <img class=\"halfScaleC 20-brazil\" style=\"top:531px; left:192px;\" src=\"/2021/static/_content/20-brazil-gold.png\">\n      <img class=\"halfScaleC 20-brazil\" style=\"top:531px; left:211px;\" src=\"/2021/static/_content/20-brazil-silver.png\">\n      <img class=\"halfScaleC 20-brazil\" style=\"top:547px; left:238px;\" src=\"/2021/static/_content/20-brazil-bronze.png\">\n\n      <img class=\"halfScaleC 20-belgium\" style=\"top:321px; left:334px;\" src=\"/2021/static/_content/20-belgium-gold.png\">\n      <img class=\"halfScaleC 20-belgium\" style=\"top:337px; left:361px;\" src=\"/2021/static/_content/20-belgium-silver.png\">\n      <img class=\"halfScaleC 20-belgium\" style=\"top:337px; left:371px;\" src=\"/2021/static/_content/20-belgium-bronze.png\">\n\n      <img class=\"halfScaleC 20-gb\" style=\"top:214px; left:395px;\" src=\"/2021/static/_content/20-gb-gold.png\">\n      <img class=\"halfScaleC 20-gb\" style=\"top:230px; left:422px;\" src=\"/2021/static/_content/20-gb-silver.png\">\n      <img class=\"halfScaleC 20-gb\" style=\"top:214px; left:429px;\" src=\"/2021/static/_content/20-gb-bronze.png\">\n\n      <img class=\"halfScaleC 20-spain\" style=\"top:436px; left:409px;\" src=\"/2021/static/_content/20-spain-gold.png\">\n      <img class=\"halfScaleC 20-spain\" style=\"top:421px; left:416px;\" src=\"/2021/static/_content/20-spain-silver.png\">\n      <img class=\"halfScaleC 20-spain\" style=\"top:436px; left:444px;\" src=\"/2021/static/_content/20-spain-bronze.png\">\n\n      <img class=\"halfScaleC 20-germany\" style=\"top:173px; left:452px;\" src=\"/2021/static/_content/20-germany-gold.png\">\n      <img class=\"halfScaleC 20-germany\" style=\"top:156px; left:460px;\" src=\"/2021/static/_content/20-germany-silver.png\">\n      <img class=\"halfScaleC 20-germany\" style=\"top:173px; left:486px;\" src=\"/2021/static/_content/20-germany-bronze.png\">\n\n      <img class=\"halfScaleC 20-greece\" style=\"top:543px; left:466px;\" src=\"/2021/static/_content/20-greece-gold.png\">\n      <img class=\"halfScaleC 20-greece\" style=\"top:543px; left:477px;\" src=\"/2021/static/_content/20-greece-silver.png\">\n      <img class=\"halfScaleC 20-greece\" style=\"top:527px; left:483px;\" src=\"/2021/static/_content/20-greece-bronze.png\">\n\n      <img class=\"halfScaleC 20-bulgaria\" style=\"top:582px; left:461px;\" src=\"/2021/static/_content/20-bulgaria-gold.png\">\n      <img class=\"halfScaleC 20-bulgaria\" style=\"top:598px; left:487px;\" src=\"/2021/static/_content/20-bulgaria-silver.png\">\n      <img class=\"halfScaleC 20-bulgaria\" style=\"top:598px; left:498px;\" src=\"/2021/static/_content/20-bulgaria-bronze.png\">\n\n      <img class=\"halfScaleC 20-italy\" style=\"top:488px; left:476px;\" src=\"/2021/static/_content/20-italy-gold.png\">\n      <img class=\"halfScaleC 20-italy\" style=\"top:471px; left:483px;\" src=\"/2021/static/_content/20-italy-silver.png\">\n      <img class=\"halfScaleC 20-italy\" style=\"top:471px; left:503px;\" src=\"/2021/static/_content/20-italy-bronze.png\">\n\n      <img class=\"halfScaleC 20-croatia\" style=\"top:109px; left:477px;\" src=\"/2021/static/_content/20-croatia-gold.png\">\n      <img class=\"halfScaleC 20-croatia\" style=\"top:94px; left:484px;\" src=\"/2021/static/_content/20-croatia-silver.png\">\n      <img class=\"halfScaleC 20-croatia\" style=\"top:109px; left:512px;\" src=\"/2021/static/_content/20-croatia-bronze.png\">\n  \n\n\n      <div class=\"addContentLink\" style=\"top:781px;left:111px;width:78px;height:15px;\">\n        <a href=\"https://live.fig-gymnastics.com/medals.php?idevent=15571\" target=\"_blank\"></a>\n      </div>\n    ",
    "script": "\n      function onPageEnter() {\n        pg20Anim = new TimelineMax();\n        pg20Anim.staggerFromTo(cOf(\"20-usa\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1)\n        .staggerFromTo(cOf(\"20-brazil\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.2)\n        .staggerFromTo(cOf(\"20-belgium\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.3)\n        .staggerFromTo(cOf(\"20-gb\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.4)\n        .staggerFromTo(cOf(\"20-spain\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.45)\n        .staggerFromTo(cOf(\"20-germany\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.5)\n        .staggerFromTo(cOf(\"20-greece\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.5)\n        .staggerFromTo(cOf(\"20-bulgaria\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.5)\n        .staggerFromTo(cOf(\"20-italy\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.55)\n        .staggerFromTo(cOf(\"20-croatia\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.55)\n        setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 5000);\n      }\n\n      function onPageLeave() {\n        pg20Anim.stop();\n        removeContentLinks();\n    }\n    ",
    "searchText": "Highlights of 2021  Tokyo 2020  CROATIA  – 1  –  GERMANY  –  1 –  GREAT BRITAIN  1  – 2  BELGIUM  1 –– UNITED STATES OF AMERICA  2  2  2 SPAIN  –  1 – ITALY  – BRAZIL  1  1 –  1  1  GREECE  –– 1 BULGARIA  1 ––  AN INCREASINGLY UNIVERSAL SPORT A record 20 nations earned a place on the podium in Tokyo to underline Gymnastics' ever more global appeal. 20  FIG YEARBOOK 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n      \n      <img class=\"halfScaleC 21-turkey\" style=\"top:491px; left:61px;\" src=\"/2021/static/_content/21-turkey-gold.png\">\n      <img class=\"halfScaleC 21-turkey\" style=\"top:491px; left:73px;\" src=\"/2021/static/_content/21-turkey-silver.png\">\n      <img class=\"halfScaleC 21-turkey\" style=\"top:476px; left:79px;\" src=\"/2021/static/_content/21-turkey-bronze.png\">\n\n      <img class=\"halfScaleC 21-israel\" style=\"top:569px; left:58px;\" src=\"/2021/static/_content/21-israel-gold.png\">\n      <img class=\"halfScaleC 21-israel\" style=\"top:585px; left:83px;\" src=\"/2021/static/_content/21-israel-silver.png\">\n      <img class=\"halfScaleC 21-israel\" style=\"top:585px; left:95px;\" src=\"/2021/static/_content/21-israel-bronze.png\">\n\n      <img class=\"halfScaleC 21-belarus\" style=\"top:80px; left:90px;\" src=\"/2021/static/_content/21-belarus-gold.png\">\n      <img class=\"halfScaleC 21-belarus\" style=\"top: 96px; left:116px;\" src=\"/2021/static/_content/21-belarus-silver.png\">\n      <img class=\"halfScaleC 21-belarus\" style=\"top:80px; left:121px;\" src=\"/2021/static/_content/21-belarus-bronze.png\">\n\n      <img class=\"halfScaleC 21-armenia\" style=\"top:600px; left:163px;\" src=\"/2021/static/_content/21-armenia-gold.png\">\n      <img class=\"halfScaleC 21-armenia\" style=\"top: 600px; left:175px;\" src=\"/2021/static/_content/21-armenia-silver.png\">\n      <img class=\"halfScaleC 21-armenia\" style=\"top:585px; left:182px;\" src=\"/2021/static/_content/21-armenia-bronze.png\">\n\n      <img class=\"halfScaleC 21-ct\" style=\"top:458px; left:345px;\" src=\"/2021/static/_content/21-ct-gold.png\">\n      <img class=\"halfScaleC 21-ct\" style=\"top:441px; left:352px;\" src=\"/2021/static/_content/21-ct-silver.png\">\n      <img class=\"halfScaleC 21-ct\" style=\"top:458px; left:380px;\" src=\"/2021/static/_content/21-ct-bronze.png\">\n\n      <img class=\"halfScaleC 21-roc\" style=\"top:107px; left:360px;\" src=\"/2021/static/_content/21-roc-gold.png\">\n      <img class=\"halfScaleC 21-roc\" style=\"top:107px; left:382px;\" src=\"/2021/static/_content/21-roc-silver.png\">\n      <img class=\"halfScaleC 21-roc\" style=\"top:107px; left:404px;\" src=\"/2021/static/_content/21-roc-bronze.png\">\n\n      <img class=\"halfScaleC 21-japan\" style=\"top:387px; left:394px;\" src=\"/2021/static/_content/21-japan-gold.png\">\n      <img class=\"halfScaleC 21-japan\" style=\"top:387px; left:416px;\" src=\"/2021/static/_content/21-japan-silver.png\">\n      <img class=\"halfScaleC 21-japan\" style=\"top:387px; left:438px;\" src=\"/2021/static/_content/21-japan-bronze.png\">\n\n      <img class=\"halfScaleC 21-nz\" style=\"top:520px; left:426px;\" src=\"/2021/static/_content/21-nz-gold.png\">\n      <img class=\"halfScaleC 21-nz\" style=\"top:520px; left:437px;\" src=\"/2021/static/_content/21-nz-silver.png\">\n      <img class=\"halfScaleC 21-nz\" style=\"top:504px; left:443px;\" src=\"/2021/static/_content/21-nz-bronze.png\">\n\n      <img class=\"halfScaleC 21-proc\" style=\"top:248px; left:486px;\" src=\"/2021/static/_content/21-proc-gold.png\">\n      <img class=\"halfScaleC 21-proc\" style=\"top:248px; left:508px;\" src=\"/2021/static/_content/21-proc-silver.png\">\n      <img class=\"halfScaleC 21-proc\" style=\"top:248px; left:530px;\" src=\"/2021/static/_content/21-proc-bronze.png\">\n\n      <img class=\"halfScaleC 21-rok\" style=\"top:373px; left:501px;\" src=\"/2021/static/_content/21-rok-gold.png\">\n      <img class=\"halfScaleC 21-rok\" style=\"top:388px; left:528px;\" src=\"/2021/static/_content/21-rok-silver.png\">\n      <img class=\"halfScaleC 21-rok\" style=\"top:373px; left:533px;\" src=\"/2021/static/_content/21-rok-bronze.png\">\n    ",
    "script": "\n      function onPageEnter() {\n        pg20Anim = new TimelineMax();\n        pg20Anim.staggerFromTo(cOf(\"21-turkey\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.65)\n        .staggerFromTo(cOf(\"21-israel\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.65)\n        .staggerFromTo(cOf(\"21-belarus\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.7)\n        .staggerFromTo(cOf(\"21-armenia\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.75)\n        .staggerFromTo(cOf(\"21-ct\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.8)\n        .staggerFromTo(cOf(\"21-roc\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.85)\n        .staggerFromTo(cOf(\"21-japan\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.9)\n        .staggerFromTo(cOf(\"21-nz\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.95)\n        .staggerFromTo(cOf(\"21-proc\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 2)\n        .staggerFromTo(cOf(\"21-rok\"), 0.3, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 2.05)\n      }\n\n      function onPageLeave() {\n        pg20Anim.stop();\n    }\n    ",
    "searchText": "Tokyo 2020  Highlights of 2021  BELARUS  1 – 1  ROC  2  4  4  PEOPLE'S REPUBLIC OF CHINA  4  1  2  REPUBLIC OF KOREA  JAPAN  2  5  1 – 1  2  CHINESE TAIPEI  – 1  –  TURKEY  –– 1  NEW ZEALAND  –– 1  ISRAEL  2 ––  ARMENIA  –– 1  20 11 A record number of nations won medals at Tokyo 2020  Most medals won by country: China  3  Number of countries to win their first Olympic gold medal in Gymnastics: Belgium Brazil, Israel  IFSC ANNUAL REPORT 2021  FIG YEARBOOK 2021  21"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top:758px;left:325px;width:191px;height:15px;\">\n          <a href=\"https://www.americanathletic.com\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:776px;left:325px;width:221px;height:19px;\">\n          <a href=\"mailto:AskAAI@americanathletic.com\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:797px;left:325px;width:95px;height:15px;\">\n          <a href=\"https://facebook.com/americanathletic\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top: 111px; left: 169px; width: 293px; height: 26px; \">\n        <a href=\"https://www.ritmica-amaya.com\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function() {\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Congress"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top:536px;left:290px;width:131px;height:15px;\">\n          <a href=\"https://www.gymnastics.sport/site/news/displaynews.php?urlNews=3380191\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Congress  Antalya 2021  DISCUSSIONS, DECISIONS, VOTES IN ANTALYA, TURKEY Ethics, finance and education were all on the agenda at the Congress, which also welcomed some new members to the FIG family.  Above The gathering in Turkey of the global Gymnastics family  26  FIG YEARBOOK 2021  “I  would like to express my heartfelt appreciation to the delegations who have come all the way to Antalya by overcoming a lot of obstacles.” These were the words of FIG President Morinari Watanabe as he welcomed delegates to Antalya for the 83rd FIG Congress. In total, delegates from 130 countries were present for the Congress, which took place from 5-7 November 2021 and featured not only elections but some significant decisions concerning the direction and daily operations of the FIG. The general assembly on the opening day included reports – from the FIG President, the committees governing each discipline, and the continental unions – as well as several proposals, notably regarding financial matters.  TERMS OF OFFICE The Congress ratified the decision of the FIG Executive Committee to reduce the next terms of office for all positions to three years instead of four, in order to correspond with the Olympic cycle leading up to the Paris 2024 Games. It meant that the mandates of those officials elected by the Congress would run from 1 January 2022 to 31 December 2024. This exceptional measure was required following the postponement to 2021 of both the Tokyo Olympic Games and the FIG electoral Congress, which led to one-year extensions of the terms of the FIG Authorities."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"27-no1\" class=\"abs merriweather-bold 27-no\" style=\"left: 483px; top: 187px; font-size: 2em; font-weight:300; margin:0; color:#e73b1f; padding:0; margin:0;\"  data-number='{\"to\": 130}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg27Anim = new TimelineMax();\n          pg27Anim.fromTo(cOf(\"27-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"27-no\")[0]);}}, 1)\n        }\n\n        function onPageLeave() {\n          pg27Anim.stop();\n          resetNumbers(\"27-no\")\n        }\n      ",
    "searchText": "Antalya 2021  Congress  130 countries represented at the Congress  FIG YEARBOOK 2021  27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"28-no1\" class=\"abs merriweather-bold 28-no\" style=\"left: 474px; top: 500px; font-size: 2em; font-weight:300; margin:0; color:#e73b1f; padding:0; margin:0;\"  data-number='{\"to\": 7}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n          pg28Anim.fromTo(cOf(\"28-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"28-no\")[0]);}}, 1)\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();\n          resetNumbers(\"28-no\")\n        }\n      ",
    "searchText": "Congress  Antalya 2021  GYMNASTICS ETHICS FOUNDATION The early efforts of the Gymnastics Ethics Foundation (GEF), the recently created adjudicatory body independent of the FIG, were outlined in a report by its President, Ms Micheline Calmy-Rey. She told the assembly that, since its establishment in January 2019, the GEF had dealt with more than 97 cases, 45 of them open at the time of the Congress. She emphasised the crucial role that national federations must play in safeguarding athletes and other participants in Gymnastics from harassment and non-accidental violence. She also pointed to the GEF’s capacity to intervene when national systems do not exist or are insufficient.  FINANCIAL MATTERS The Congress approved the 2018, 2019 and 2020 accounts after a comprehensive overview given by FIG Secretary General Nicolas Buompane. The net result of the last quadrennial period 2017–2020 substantially exceeded the amount initially expected, due to sponsorship income, delayed events and activities caused by the health crisis, and financial investments. Additionally, the Congress approved the quadrennial plan for 2021-24, with  28  FIG YEARBOOK 2021  cautious projections foreseeing a net loss at the end of the exercise. The delegates also voted to maintain the current annual membership fees paid by the national federations for the period 2021-24.  SEVEN WELCOMED INTO FIG The governing body continued its push to put roots in new territories around the world by welcoming seven affiliated members: The Democratic Republic of the Congo (COD), Guam (GUM), Haiti (HAI), Lesotho (LES), Rwanda (RWA), Sierra Leone (SLE) and Togo (TOG). With Antigua and Barbuda (ANT), which recently joined the FIG as associated members, the FIG now counts a total of 156 member federations – 154 affiliated members and two associated members.  7 new member federations welcomed into the FIG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Antalya 2021  HONORARY VICE-PRESIDENTS Margaret Sikkens Ahlquist (SWE), Nataliya Kuzmina (RUS) and Horst Kunze (GER) – respectively the outgoing committee Presidents for Gymnastics for All, Rhythmic Gymnastics and Trampoline Gymnastics – were named Honorary Vice-Presidents for their longstanding involvement in Gymnastics.  STATUTES TWEAKED The Congress approved several modifications to the Statutes, including the removal of some disciplinary proceedings now under the jurisdiction of the GEF. Other changes included the harmonisation of the time-delay conditions for all requests for changes of nationality and the conditions of the judges’ brevet required for candidacy for a Technical Committee position. Another decision was to make English the only official language used in presentations at the Congress and the main official documents. Translations into other languages will continue to be provided for the Code of Points. The delegates also gave the green light to a broad revision process aimed  at overhauling the structure of the Statutes. This revision will focus mainly on enhancing the wording to make the rules easier to understand for a large number of people and to meet the standards of good practice and good governance expected from an international federation.  Congress  Above Inside the Congress hall  NEW EDUCATION PLATFORM Delegates had the opportunity for a first look at the new eLearning platform that was due to be rolled out in early 2022 – first for the Level 1 Academies and the Foundation courses. This platform is aimed at modernising the offer of education programmes, increasing the number of participants in the Academies in all disciplines, and reducing costs. A source of scientific and technical knowledge about all disciplines of Gymnastics, it will offer a wide range of material, technical manuals, lectures and webinars from renowned experts.  NEXT TIME Norway will host the next FIG Congress on 21-22 October 2022 at the Oslofjord Convention Center, Sandefjord, near the city of Tonsberg.  FIG YEARBOOK 2021  29"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:215px;left:51px;width:54px;height:15px;\">\n        <a href=\"https://www.gymnastics.sport/site/news/displaynews.php?urlNews=3377856\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:402px;left:339px;width:120px;height:15px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/about-president.php\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Congress  Elections  MORINARI WATANABE RE-ELECTED PRESIDENT Elections were held also for the FIG Vice-Presidents, FIG Council and Executive Committee and Technical Committee members as well as auditors.  M  orinari Watanabe (JPN) was re-elected as FIG President by the member Gymnastics federations at the FIG Congress in Antalya. President Watanabe, who has been at the helm of the FIG since 1 January 2017, obtained 81 votes, against 47 for Farid Gayibov (AZE), the only other candidate for the Presidency.  NINTH FIG PRESIDENT Elected for an initial four-year term at the Tokyo Congress in October 2016, President Watanabe said: “I want to thank you from the bottom of my heart for believing in me. My policy as FIG President is to support the national federations.”  President in profile Born on 21 February 1959, Morinari Watanabe gained an undergraduate degree and then an MA in Physical Education from Tokyo’s Tokai University, spending two years in between studying at the Vassil Levski National Sports Academy in Sofia (BUL). An executive with AEON, the Japanese retail group, he entered the Japan Gymnastics Association (JGA) as managing director in 1996, before becoming its secretary general in 2009. In his time at the JGA he was widely credited for the success of Japanese athletes on the World and Olympic scene after a fallow period, medals-wise, at the 1996 and 2000 Olympic Games. In his first term of office, he achieved progress in a variety of areas, from promoting Parkour – which led to its inclusion as the urban discipline of the FIG – to partnering the FIG with Fujitsu to develop technology to support judging. It was his idea to establish the Gymnastics Ethics Foundation, as an independent body dealing with safeguarding cases, and he supported greater gender equality among FIG officials. He also advocated greater support for developing countries. He was named a member of the International Olympic Committee (IOC) in 2018 and was elected as a Council member of the Association of the Summer Olympic International Federations (ASOIF) in 2019.  30  FIG YEARBOOK 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 31-quote-1\" style=\"top:575px;right:234px;\" src=\"/2021/static/_content/31-quote-1.png\">\n\n        <h1 id=\"31-no1\" class=\"abs merriweather-bold 31-no\" style=\"left: 498px; top: 742px; font-size: 2em; font-weight:300; margin:0; color:#e73b1f; padding:0; margin:0;\"  data-number='{\"to\": 81}' ></h1>\n\n        <div class=\"addContentLink\" style=\"top:655px;left:250px;width:107px;height:18px;\">\n          <a href=\"https://gymnastics.sport/publicdir/congress/election.php?display=president\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:673px;left:250px;width:82px;height:17px;\">\n          <a href=\"https://gymnastics.sport/publicdir/congress/election.php?display=president\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg31Anim = new TimelineMax();\n          pg31Anim.fromTo(cOf(\"31-quote-1\"), 1, {opacity:0, x:-120}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"31-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[0]);}}, 1.3)\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 2000);\n        }\n\n        function onPageLeave() {\n          pg31Anim.stop();\n          resetNumbers(\"31-no\")\n        }\n      ",
    "searchText": "Elections  Congress  Left FIG VicePresidents Suat Celen, Ali Al-Hitmi and Nellie Kim Bottom left FIG President Morinari Watanabe  “   The FIG and the national federations share their problems and together we try to solve them.” Morinari Watanabe  “I have visited many countries and have seen the training facilities they have. I have talked to athletes and officials in each country while looking into their eyes. The FIG and the national federations share their problems and together we try to solve them. Let’s build a bright future together.”  THE FIG AUTHORITIES FOR 2022-2024 The election of the President was followed by the elections for the other FIG Authorities, starting with the three vice-presidents: Ali Al-Hitmi (QAT), who gained election as 1st Vice-President; Nellie Kim (BLR), who was re-elected as 2nd Vice-President; and Suat Celen (TUR), elected as 3rd Vice-President. The mandates of all officials will run from 1 January 2022 until 31 December 2024.  81 votes obtained by Morinari Watanabe  FIG YEARBOOK 2021  31"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Congress  Elections  THE FIG AUTHORITIES FOR 2022-2024 EXECUTIVE COMMITTEE PRESIDENT  Morinari Watanabe (JPN)  VICE-PRESIDENTS  Ali Al-Hitmi (QAT) 1st Vice-President  Nellie Kim (BLR) 2nd Vice-President  Suat Celen (TUR) 3rd Vice-President  Jani Tanskanen (FIN) Member  MEMBERS  32  Li Li Leung (USA) Member  Miao Zhongyi (CHN) Member  Maria Fumea (ROU) Member  Vassily Titov (RUS) Member  Youssef Al-Tabbaa (SYR) Member  Alejandro Peniche (MEX) Member  FIG YEARBOOK 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Elections  Rogerio Valerio (POR) GFA-C President  Arturs Mickevics (LAT) MAG-TC President  Donatella Sacchi (ITA) WAG-TC President  Christophe Lambert (FRA) TRA-TC President  Rosy Taeymans (BEL) ACRO-TC President  Tammy Yagi-Kitagawa (JPN) AER-TC President  Abdulrahman Alshathri (QAT) AGU President  Ehab Esawy (EGY) UAG President  *  Aljaz Pegan (SLO) Athletes’ Commission President *  *  Charles Perriere (FRA) PK-CO President (named in 2018)  Congress  Noha Abou Shabana (EGY) RG-TC President  Naomi Valenzo Aoki (MEX) PAGU President  *  *  Farid Gayibov (AZE) EG President  Kitty Chiller (AUS) OGU President *  *(not elected at Congress)  FIG YEARBOOK 2021  33"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Congress  Elections  African Gymnastics Union  Asian Gymnastics Union  European Gymnastics  FIG COUNCIL MEMBERS  34  Lise Lorentzen Mandal (NOR) Member  Athanasoula Lampropoulou S. (GRE) Member  Daniela Delle Chiaie (ITA) Member  Stoian Dimitrov (BUL) Member  Jacob Wischnia (ISR) Member  Sandor Altorjaj (HUN) Member  Saqer Almulla (KUW) Member  Cynthia Norton (PHI) Member  Ruslan Mustaev (UZB) Member  Ita Yuliati (INA) Member  Sofiane Zahi (ALG) Member  Elizabeth Smith (RSA) Member  Abdessadeq Bitari (MAR) Member  Hala Salama Youssef Hamoud (EGY) Member  FIG YEARBOOK 2021  Edvard Kolar (SLO) Member  Srayuth Patanasak (THA) Member"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Juan Navor Medina Lopez (COL) Member  Maria Luciene Cacho Resende (BRA) Member  Kenia Herrera (NCA) Member  Patricia Dieguez Pilona (GUA) Member  Oceania Gymnastics Union  Pan-American Gymnastics Union  Elections  Congress  Denis Mowbray (NZL) Member  FIG YEARBOOK 2021  35"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "MEN’S ARTISTIC GYMNASTICS TECHNICAL COMMITTEE  GYMNASTICS FOR ALL COMMITTEE  Congress  36  Elections  Rogerio Valerio (POR) President  Monika Siskova (SVK) Vice-President  Tatsuo Araki (JPN) Vice-President  Marco Bortoleto (BRA) Member  Jerome Huebscher (SUI) Member  Petrina Hutchinson (AUS) Member  Arturs Mickevics (LAT) President  Jeffrey Thomson (CAN) Vice-President  Andrew Tombs (GBR) Vice-President  Yoon Soo Han (KOR) Member)  Dmitrii Andreev (RUS) Member  Julio Marcos Felipe (ESP) Member  Andreja Zunich (USA) Member  Aljaz Pegan (SLO) Athletes' Representative  FIG YEARBOOK 2021  Gemma Barton (GBR) Member  *"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RHYTHMIC GYMNASTICS TECHNICAL COMMITTEE  WOMEN’S ARTISTIC GYMNASTICS TECHNICAL COMMITTEE  Elections  Congress  Donatella Sacchi (ITA) President  Nehad Zayed (EGY) Vice-President  Liubov Andrianova (RUS) Vice-President  Elena Davydova (CAN) Member  Kym Dowdell (AUS) Member  Johanna Gratt (AUT) Member  Helena Lario (ARG) Member  Catalina Ponor (ROU) Athletes' Representative  Noha Abou Shabana (EGY) President  Isabell Sawade (GER) Vice-President  Maria Petrova Mihaylova (BUL) Vice-President  Natalya Bulanova (AZE) Member  Marcia Aversani Lourenco (BRA) Member  Marie Moltubakk (NOR) Member  Liubou Charkashyna (BLR) Member  *  Siyana Vasileva (AZE) Athletes' Representative  *  *(not elected at Congress)  FIG YEARBOOK 2021  37"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "TRAMPOLINE TECHNICAL COMMITTEE  Congress  Elections  Christophe Lambert (FRA) President  Tetiana Shuiska (UKR) Vice-President  Miguel Vicente Marino (ESP) Vice-President  Liu Xing (CHN) Member  Shinya Muto (JPN) Member  Rosy Taeymans (BEL) President  Tomas Bernardo (POR) Vice-President  Nikolina Hristova (BUL) Vice-President  Wieslawa Milewska (POL) Member  Frank Boehm (GER) Member  Yurii Goliak (UKR) Member  Irina Nikitina (RUS) Member  May Miller (ISR) Athletes' Representative  ACROBATIC GYMNASTICS TECHNICAL COMMITTEE  Dmitri Poliaroush (BLR) Member  38  FIG YEARBOOK 2021  Mariela Stoycheva (BUL) Member  Rosannagh MacLennan (CAN) Athletes' Representative  *  *"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "AUDITORS  AEROBIC GYMNASTICS TECHNICAL COMMITTEE  Elections  Tammy Yagi-Kitagawa (JPN) President  Jorge Fillon (ARG) Vice-President  Vladislav Oskner (RUS) Member  Ana Macanita (POR) Member  Ron Froehlich (USA) Auditor  Hanspeter Tschopp (SUI) Auditor  Vincent Bernasconi (SUI) Professional Auditor  Congress  Cristina Casentini (ITA) Vice-President  Desislava Bogusheva (BUL) Member  Maria Eduarda De Oliveira Poli (BRA) Member  Dora Hegyi (HUN) Athletes' Representative  *  *  *(not elected at Congress)  FIG YEARBOOK 2021  39"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Congress  Elections  HONORARY VICE-PRESIDENTS  Margaret Sikkens Ahlquist (SWE)  Horst Kunze (GER)  Nataliya Kuzmina (RUS)  HONORARY members Huang Liping (CHN)  Hong Wang (CHN)  Luo Chaoyi (CHN)  Qiurui Zhou (CHN)  Flemming Knudsen (DEN)  Sergio Garcia Alcazar (ESP)  Karl Wharton (GBR)  Holger Albrecht (GER)  Kim Dong Min (KOR)  Shihoko Sekita (JPN)  Nikolai Makarov (RUS)  40  FIG YEARBOOK 2021  Caroline Hunt (USA)  Svetlana Lukina (RUS)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:775px;left:187px;width:269px;height:21px;\">\n        <a href=\"https://www.cannice-sports.com\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:855px;left:337px;width:145px;height:12px;\">\n        <a href=\"mailto:export@cannice-sports.com\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "No. 6596, East Dongfanghong Road, Economic and Development Zone, Dezhou, Shandong Province, China Tel: +86 (0) 534 8100909 - E-mail: expor t@cannice-spor ts.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Sport"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Sport  World Championships  THE SHOW GOES ON Kitakyushu, Japan, made history by staging World Championships in both Artistic and Rhythmic – as 2021 witnessed Worlds in five disciplines.  I  f the challenge of organising one World Championships during this period of the COVID-19 pandemic was formidable, consider the scale of the task facing Kitakyushu (JPN) in the lead-up to October 2021. After all, the city on Japan’s southernmost island of Kyushu staged not one but two World Championships as, for the first time, the FIG Artistic and Rhythmic  44  FIG YEARBOOK 2021  Gymnastics World Championships were held back-to-back in the same location. Yet two months after the Tokyo Olympics, both events unfolded successfully as Kitakyushu delivered Japan’s first major sporting event with spectators since before the pandemic took hold, having received the green light for crowds just one month in advance of the World Championships."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "World Championships  The 50th Artistic Gymnastics World Championships had initially been scheduled to take place in Copenhagen before the Danish Gymnastics Federation withdrew as hosts in 2020. So it was that the Kitakyushu City General Gymnasium provided the stage from 18-24 October for the gymnasts from 56 nations who had descended on southern Japan.  Every delegation received a warm welcome from local schools designated to provide messages of support to each competing nation. They witnessed plenty of innovation too. Thanks to the Virtual Media Centre, members of the international media unable to travel to Japan had the opportunity to interact directly with gymnasts. Moreover, with Kitakyushu residents contributing unwanted mobile phones, the medals  Sport  Above Rhythmic Gymnastics’ venue in Kitakyushu  FIG YEARBOOK 2021  45"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Sport  World Championships  awarded to gymnasts were made from recycled metals. Other innovative aspects were the first Fujitsu Infinity Award honouring a national federation in both Men’s and Women’s Artistic Gymnastics, and the new Tokio Inkarami Prize for Style which would be awarded after the spotlight had switched to the West Japan General Exhibition Center Annex for the Aeon Rhythmic Gymnastics World Championships 2021 between 27-31 October. Forty-seven nations were represented in what were the third Rhythmic Worlds held in Japan and the first featuring the new format which capped the number of individual competitors at 105, with quota places attained through the continental championships held in 2020 and 2021 (in which more than 50 nations earned the right to send at least one individual competitor). For the first time too, a Team champion, RGF, was determined by adding each federation’s eight scores from Individual qualifications to the two scores of the Group All-Around competition.  A fitting farewell to Uchimura Kitakyushu, the northernmost city on Japan’s southernmost island of Kyushu, is the birthplace of Uchimura Kohei, the six-time World and two-time Olympic All-Around champion. As such it provided a fitting setting for his final World Championship participation, the 32-yearold bowing out with a sixth-place finish on Horizontal Bar.  START AND FINISH IN BAKU Overall there were five World Championships in 2021, starting with the 16th Aerobic Gymnastics World Championships held in Baku (AZE) from 27-29 May. Owing to the global health situation, there had been only one World Cup event, in Sofia (BUL) in April, in this discipline and gymnasts from several prominent Asian countries were not among the 22 nations who participated at the National Gymnastics Arena. That was the first Aerobic Worlds hosted in the Azeri capital and Baku marked another such first late in the year with the 35th Trampoline World Championships between 18-21 November. Altogether more than 250 athletes from Trampoline’s four disciplines – Individual, Synchronised, Double Mini-trampoline (DMT), and Tumbling – registered to compete, with a total of 33 nations involved. Last but not least, Geneva (SUI) provided the stage for the 27th Acrobatic World Championships between 2-4 July. After a year that saw the cancellation of much of the international competition calendar in Acrobatic, 20 nations took part at the lakeside Patinoire des Vernets as  46  FIG YEARBOOK 2021  Switzerland hosted its first World Championships in any Gymnastics discipline this century. The 11th Acrobatics World Age Group Competitions (WAGC) for age-group and junior-level competitors took place from 23-29 June in Geneva. Baku similarly hosted Aerobic’s ninth World Age Group Competitions from 21-23 May prior to the Worlds and Trampoline’s 28th WAGC from 25-28 November following the senior event.  Above Japan’s Uchimura Kohei competes for the last time on the world stage Right Japan’s Murakami Mai celebrates gold on Floor Exercise"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 47-globe-icon-1\" style=\"top:573px;left:120px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 47-globe-icon-1\" style=\"top:573px;left:144px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 47-globe-icon-1\" style=\"top:548px;left:120px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 47-globe-icon-1\" style=\"top:548px;left:144px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 47-globe-icon-1\" style=\"top:523px;left:120px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 47-globe-icon-1\" style=\"top:523px;left:144px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 47-globe-icon-1\" style=\"top:498px;left:120px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 47-globe-icon-1\" style=\"top:498px;left:144px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 47-globe-icon-1\" style=\"top:473px;left:120px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 47-globe-icon-1\" style=\"top:473px;left:144px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 47-globe-icon-1\" style=\"top:448px;left:132px;\" src=\"/2021/static/_content/globe-icon.png\">\n\n        <h1 id=\"47-no1\" class=\"abs worksans-black 47-no\" style=\"left: 122px; top: 606px; font-size: 2.6em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 11}' ></h1>\n\n        <img class=\"halfScale 47-medal-icon-1\" style=\"top:726px;left:172px;\" src=\"/2021/static/_content/medal-icon.png\">\n        <img class=\"halfScale 47-medal-icon-1\" style=\"top:726px;left:187px;\" src=\"/2021/static/_content/medal-icon.png\">\n        <img class=\"halfScale 47-medal-icon-1\" style=\"top:726px;left:202px;\" src=\"/2021/static/_content/medal-icon.png\">\n        <img class=\"halfScale 47-medal-icon-1\" style=\"top:726px;left:217px;\" src=\"/2021/static/_content/medal-icon.png\">\n\n        <h1 id=\"47-no1\" class=\"abs worksans-black 47-no\" style=\"left: 146px; top: 724px; font-size: 1.4em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 4}' ></h1>\n\n        <img class=\"halfScale 47-medal-icon-2\" style=\"top:693px;left:298px;\" src=\"/2021/static/_content/medal-icon.png\">\n        <img class=\"halfScale 47-medal-icon-2\" style=\"top:693px;left:313px;\" src=\"/2021/static/_content/medal-icon.png\">\n\n        <h1 id=\"47-no1\" class=\"abs worksans-black 47-no\" style=\"left: 276px; top: 690px; font-size: 1.4em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 2}' ></h1>\n\n        <img class=\"halfScale 47-1st-1\" style=\"top:634px;left:438px;\" src=\"/2021/static/_content/47-1st-1.png\">\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg47Anim = new TimelineMax();\n          pg47Anim.staggerFromTo(cOf(\"47-globe-icon-1\"), 1, {opacity:0, y:-30}, {opacity:1, y:0, ease: Power2.easeOut}, 0.1, 1)\n          .fromTo(cOf(\"47-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"47-no\")[0]);}}, 1)\n          .staggerFromTo(cOf(\"47-medal-icon-1\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.1, 1.5)\n          .fromTo(cOf(\"47-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"47-no\")[1]);}}, 1.5)\n          .staggerFromTo(cOf(\"47-medal-icon-2\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.1, 2)\n          .fromTo(cOf(\"47-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"47-no\")[2]);}}, 2)\n          .staggerFromTo(cOf(\"47-1st-1\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.1, 2.5)\n        }\n\n        function onPageLeave() {\n          pg47Anim.stop();\n          resetNumbers(\"47-no\")\n        }\n      ",
    "searchText": "World Championships  Sport  WORLDS in numbers Five FIG World Championships took place in 2021 – and here are some of the outstanding stats.  ARTISTIC  11  nations represented on the podium  4  gold medals won by the People’s Republic of China, including two for Hu Xuwei on Parallel Bars and Horizontal Bar  ST 1Rebeca Andrade (BRA),  2  golds for Japan’s Murakami Mai and Ashikawa Urara on Floor Exercise and Balance Beam marked a best-ever result for the host nation’s women  Carlos Yulo (PHI), Stephen Nedoroscik (USA) and Nicola Bartolini (ITA) each made history for their nation with a first world title in women’s Vault, men’s Vault, Pommel Horse and men’s Floor Exercise. In the case of Andrade, her gold was only Brazil’s second World title in Women’s Artistic Gymnastics, 18 years after the first  FIG YEARBOOK 2021  47"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 48-globe-icon-1\" style=\"top:303px;left:96px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-1\" style=\"top:303px;left:120px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-1\" style=\"top:278px;left:96px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-1\" style=\"top:278px;left:120px;\" src=\"/2021/static/_content/globe-icon.png\">\n       \n        <h1 id=\"48-no1\" class=\"abs worksans-black 48-no\" style=\"left: 55px; top: 285px; font-size: 2.6em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 4}' ></h1>\n\n        <h1 id=\"48-no1\" class=\"abs worksans-black 48-no\" style=\"left: 186px; top: 269px; font-size: 1.4em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 22}' ></h1>\n\n        <h1 id=\"48-no1\" class=\"abs worksans-black 48-no\" style=\"left: 440px; top: 260px; font-size: 1.4em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 8}' ></h1>\n\n        <img class=\"halfScale 48-globe-icon-2\" style=\"top:798px;left:101px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-2\" style=\"top:798px;left:125px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-2\" style=\"top:798px;left:149px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-2\" style=\"top:798px;left:173px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-2\" style=\"top:798px;left:198px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-2\" style=\"top:773px;left:101px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-2\" style=\"top:773px;left:125px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-2\" style=\"top:773px;left:149px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-2\" style=\"top:773px;left:173px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-2\" style=\"top:773px;left:198px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-2\" style=\"top:748px;left:101px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-2\" style=\"top:748px;left:125px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-2\" style=\"top:748px;left:149px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-2\" style=\"top:748px;left:173px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 48-globe-icon-2\" style=\"top:748px;left:198px;\" src=\"/2021/static/_content/globe-icon.png\">\n\n        <h1 id=\"48-no1\" class=\"abs worksans-black 48-no\" style=\"left: 50px; top: 778px; font-size: 2.6em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 15}' ></h1>\n\n        <img class=\"halfScale 48-1st-1\" style=\"top:741px;left:266px;\" src=\"/2021/static/_content/48-1st-1.png\">\n\n        <img class=\"halfScale 48-medal-icon-1\" style=\"top:738px;left:423px;\" src=\"/2021/static/_content/medal-icon.png\">\n        <img class=\"halfScale 48-medal-icon-1\" style=\"top:738px;left:439px;\" src=\"/2021/static/_content/medal-icon.png\">\n        <img class=\"halfScale 48-medal-icon-1\" style=\"top:738px;left:455px;\" src=\"/2021/static/_content/medal-icon.png\">\n        \n        <h1 id=\"48-no1\" class=\"abs worksans-black 48-no\" style=\"left: 406px; top: 736px; font-size: 1.4em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 3}' ></h1>\n\n        \n\n      ",
    "script": "\n        function onPageEnter() {\n          pg48Anim = new TimelineMax();\n          pg48Anim.staggerFromTo(cOf(\"48-globe-icon-1\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, 1)\n          .fromTo(cOf(\"48-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"48-no\")[0]);}}, 1)\n          .fromTo(cOf(\"48-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"48-no\")[1]);}}, 1.5)\n          .fromTo(cOf(\"48-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"48-no\")[2]);}}, 2)\n          .staggerFromTo(cOf(\"48-globe-icon-2\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.05, 2.5)\n          .fromTo(cOf(\"48-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"48-no\")[3]);}}, 2.5)\n          .staggerFromTo(cOf(\"48-1st-1\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.1, 3)\n          .staggerFromTo(cOf(\"48-medal-icon-1\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.1, 3.5)\n          .fromTo(cOf(\"48-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"48-no\")[4]);}}, 3.5)\n        }\n\n        function onPageLeave() {\n          pg48Anim.stop();\n          resetNumbers(\"48-no\")\n        }\n      ",
    "searchText": "Sport  World Championships  RHYTHMIC  4  nations represented on the podium  8  22  Dina Averina (RGF) became her country’s most decorated gymnast at the Rhythmic Worlds as her fourth consecutive World All-Around title (in addition to golds with the Hoop, Ball, Clubs, and RGF team) took her medals’ tally to 22, 18 of them gold  For the first time in eight years, a non-Russian woman won an Individual World title as Alina Harnasko (BLR) claimed gold in Ribbon  WORLDS in numbers (continued)  TRAMPOLINE  1ST  15  nations represented on the podium  Yan Langyu (CHN) and Bryony Page (GBR) earned their first Individual World titles, in Page’s case 11 years after her first Worlds  3  Alexander Lisitsyn (RGF) was the only gymnast to earn three golds in Baku – in the men's and Tumbling Team events and the All-Around Team final"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 49-medal-icon-1\" style=\"top:185px;left:96px;\" src=\"/2021/static/_content/medal-icon.png\">\n        <img class=\"halfScale 49-medal-icon-1\" style=\"top:185px;left:81px;\" src=\"/2021/static/_content/medal-icon.png\">\n        <img class=\"halfScale 49-medal-icon-1\" style=\"top:185px;left:66px;\" src=\"/2021/static/_content/medal-icon.png\">\n        <img class=\"halfScale 49-medal-icon-1\" style=\"top:206px;left:81px;\" src=\"/2021/static/_content/medal-icon.png\">\n        <img class=\"halfScale 49-medal-icon-1\" style=\"top:206px;left:66px;\" src=\"/2021/static/_content/medal-icon.png\">\n        <img class=\"halfScale 49-medal-icon-faded-1\" style=\"top:206px;left:96px;\" src=\"/2021/static/_content/medal-icon-faded.png\">\n\n        <h1 id=\"49-no1\" class=\"abs worksans-black 49-no\" style=\"left: 114px; top: 182px; font-size: 1.4em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 5}' ></h1>\n\n        <img class=\"halfScale 49-globe-icon-1\" style=\"top:472px;left:66px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-1\" style=\"top:472px;left:90px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-1\" style=\"top:447px;left:66px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-1\" style=\"top:447px;left:90px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-1\" style=\"top:422px;left:66px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-1\" style=\"top:422px;left:90px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-1\" style=\"top:397px;left:66px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-1\" style=\"top:397px;left:90px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-1\" style=\"top:372px;left:78px;\" src=\"/2021/static/_content/globe-icon.png\">\n\n        <h1 id=\"49-no1\" class=\"abs worksans-black 49-no\" style=\"left: 65px; top: 500px; font-size: 2.6em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 9}' ></h1>\n\n        <img class=\"halfScale 49-1st-1\" style=\"top:602px;left:65px;\" src=\"/2021/static/_content/49-1st-1.png\">\n\n\n        <img class=\"halfScale 49-globe-icon-2\" style=\"top:435px;left:353px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-2\" style=\"top:435px;left:377px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-2\" style=\"top:410px;left:353px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-2\" style=\"top:410px;left:377px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-2\" style=\"top:385px;left:353px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-2\" style=\"top:385px;left:377px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-2\" style=\"top:360px;left:353px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-2\" style=\"top:360px;left:377px;\" src=\"/2021/static/_content/globe-icon.png\">\n        <img class=\"halfScale 49-globe-icon-2\" style=\"top:335px;left:365px;\" src=\"/2021/static/_content/globe-icon.png\">\n\n        <h1 id=\"49-no1\" class=\"abs worksans-black 49-no\" style=\"left: 352px; top: 457px; font-size: 2.6em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 9}' ></h1>\n\n        <h1 id=\"49-no1\" class=\"abs worksans-black 49-no\" style=\"left: 508px; top: 586px; font-size: 1.4em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 18}' ></h1>\n\n        <img class=\"halfScale 49-1st-2\" style=\"top:687px;left:346px;\" src=\"/2021/static/_content/49-1st-2.png\">\n\n        <h1 id=\"49-no1\" class=\"abs worksans-black 49-no\" style=\"left: 473px; top: 704px; font-size: 1.4em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\":3}' ></h1>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg49Anim = new TimelineMax();\n          pg49Anim.staggerFromTo(cOf(\"49-medal-icon-1\"), 1, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.1, 1)\n          .staggerFromTo(cOf(\"49-medal-icon-faded-1\"), 1, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, 0.1, 1.6)\n          .fromTo(cOf(\"49-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"49-no\")[0]);}}, 1)\n          .staggerFromTo(cOf(\"49-globe-icon-1\"), 1, {opacity:0, y:-30}, {opacity:1, y:0, ease: Power2.easeOut}, 0.1, 1.5)\n          .fromTo(cOf(\"49-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"49-no\")[1]);}}, 1.5)\n          .staggerFromTo(cOf(\"49-1st-1\"), 1, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.1, 2)\n          .staggerFromTo(cOf(\"49-globe-icon-2\"), 1, {opacity:0, y:-30}, {opacity:1, y:0, ease: Power2.easeOut}, 0.1, 2.5)\n          .fromTo(cOf(\"49-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"49-no\")[2]);}}, 2.5)\n          .fromTo(cOf(\"49-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"49-no\")[3]);}}, 3)\n          .staggerFromTo(cOf(\"49-1st-2\"), 1, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 0.1, 3.2)\n          .fromTo(cOf(\"49-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"49-no\")[4]);}}, 3.5)\n        }\n\n        function onPageLeave() {\n          pg49Anim.stop();\n          resetNumbers(\"49-no\")\n        }\n      ",
    "searchText": "World Championships  ACROBATIC  Sport  AEROBIC  won five 5 RGF of the six golds  9  nations represented on the podium  9  nations represented on the podium  18  1ST  Rita Ferreira and Ana Teixiera won Portugal’s first medal with gold in the Women’s Pair final; a second followed with bronze in the Women’s Groups  Age of Miquel Mane (ESP), the new World champion in the Individual Men’s category  1ST  Ayse Onbasi (TUR) delivered her country’s first World title (and medal) with victory in the Individual Women’s final. There was also a first medal for Azerbaijan, third in the Team final  3  Michela Castoldi and Davide Donati (ITA) took their third and final World crown in their last performance after 14 years of Mixed Pairs competition together  FIG YEARBOOK 2021  49"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Sport  World Cups  WORLD CUP ACTION RESUMES Thirteen countries provided the stage for the year’s World Cup and World Challenge Cup events across six different disciplines.  50  FIG YEARBOOK 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"51-no1\" class=\"abs merriweather-bold 51-no\" style=\"left: 484px; top: 545px; font-size: 2em; font-weight:300; margin:0; color:#e73b1f; padding:0; margin:0;\"  data-number='{\"to\": 10}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg51Anim = new TimelineMax();\n          pg51Anim.fromTo(cOf(\"51-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"51-no\")[0]);}}, 1)\n        }\n\n        function onPageLeave() {\n          pg51Anim.stop();\n          resetNumbers(\"51-no\")\n        }\n      ",
    "searchText": "T  he FIG staged nine World Cup events between March and September 2021 as well as eight World Challenge Cups, despite the challenges of the COVID-19 pandemic. There were World Cups for six disciplines and for Artistic Gymnastics, Rhythmic Gymnastics and Trampoline, the events formed part of the qualification process for the Tokyo 2020 Olympic Games. Artistic Gymnastics’ FIG Apparatus World Cup in Doha (QAT) in June completed an eight-leg series which had begun in 2018 and settled the destiny of 10 Olympic quota places – the last of them taken by two athletes, Eleftherios Petrounias (GRE, Still Rings) and Vanessa Ferrari (ITA, Floor Exercise) who would win bronze and silver respectively in Tokyo. Similarly, the Trampoline World Cup event in Anadia (POR) in June concluded the 2019-21 series in that discipline. Meanwhile, the FIG World Cup Series for Rhythmic Gymnastics comprised four events between the end of March and the end of May and the All-Around success of Linoy Ashram (ISR) foretold her subsequent gold medal at the Tokyo Games.  10 Olympic quota places confirmed in Doha  Left Italy’s Vanessa Ferrari on Floor Exercise Above Greece’s Eleftherios Petrounias on Still Rings  FIG YEARBOOK 2021  51"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Sport  World Cups  There was also a World Challenge Cup Series in Artistic Gymnastics, which had begun in Szombathely (HUN) in 2020 and concluded with a further five events between May and September. Illia Kovtun (UKR) won three of the six men’s series titles available (Floor Exercise, Pommel Horse, Parallel Bars) and Ana Derek (CRO) won two of the four women’s titles (Balance Beam, Floor Exercise). For Rhythmic Gymnastics, a threeevent World Challenge Cup series unfolded between July and October in which Lala Kramarenko (RUS) ranked first in the All-Around standings – and on all four individual apparatus. Finally, for both Acrobatic Gymnastics and Parkour, there was a single World Cup event staged in Sofia (BUL).  52  FIG YEARBOOK 2021  Above Ukraine’s Illia Kovtun on Pommel Horse Left Croatia’s Ana Derek on Balance Beam"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 53-title-1\" style=\"top:442px;left:45px;\" src=\"/2021/static/_content/53-title-1.png\">\n        <img class=\"halfScale 53-text-1\" style=\"top:510px;left:65px;\" src=\"/2021/static/_content/53-text-1.png\">\n        <img class=\"halfScaleC 53-dots-1\" style=\"top:185px; left:3px;\" src=\"/2021/static/_content/53-dots-1.png\">\n        <img class=\"halfScale 53-title-2\" style=\"top:442px;left:333px;\" src=\"/2021/static/_content/53-title-2.png\">\n        <img class=\"halfScale 53-text-2\" style=\"top:510px;left:333px;\" src=\"/2021/static/_content/53-text-2.png\">\n        <img class=\"halfScaleC 53-dots-2\" style=\"top:165px; left:188px;\" src=\"/2021/static/_content/53-dots-2.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(cOf(\"53-title-1\"), 1, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n          pg1Anim.fromTo(cOf(\"53-text-1\"), 1, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"53-dots-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.4)\n          .fromTo(cOf(\"53-title-2\"), 1, {opacity:0, x:-30}, {opacity:1, x:0, ease: Power2.easeOut}, 1.6)\n          pg1Anim.fromTo(cOf(\"53-text-2\"), 1, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, 1.8)\n          .fromTo(cOf(\"53-dots-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2)\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n      }\n      ",
    "searchText": "World Cups  Sport  15 CITIES HOST 9 WORLD CUPS AND 8 WORLD CHALLENGE CUPS 5  4  3 5 6 4  8 1 1 3  6  2  7 2 7  World Cups  World Challenge Cups  Sofia (BUL) Rhythmic – March Acrobatic – April Parkour – September  1  Varna (BUL) Artistic – May  2  2  Tashkent (UZB) Rhythmic – April  Cairo (EGY) Artistic – June  3  3  Baku (AZE) Rhythmic – May  Osijek (CRO) Artistic – June  4  4  Pesaro (ITA) Rhythmic – May  Minsk (BLR) Rhythmic – July  5  5  Brescia (ITA) Trampoline – June  Moscow (RUS) Rhythmic – July  6  6  Anadia (POR) Trampoline – June  Koper (SLO) Artistic – September  7  7  Doha (QAT) Artistic – June  Mersin (TUR) Artistic – September  8  Cluj-Napoca (ROU) Rhythmic – October  1  FIG YEARBOOK 2021  53"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"54-no1\" class=\"abs merriweather-bold 54-no\" style=\"left: 473px; top: 578px; font-size: 2em; font-weight:300; margin:0; color:#e73b1f; padding:0; margin:0;\"  data-number='{\"to\": 21}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg54Anim = new TimelineMax();\n          pg54Anim.fromTo(cOf(\"54-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"54-no\")[0]);}}, 1)\n        }\n\n        function onPageLeave() {\n          pg54Anim.stop();\n          resetNumbers(\"54-no\")\n        }\n      ",
    "searchText": "Sport  World Cups  SOFIA SPOTLIGHT HIGHLIGHTS PARKOUR PROGRESS The growing appeal of Parkour was underlined by the presence of athletes representing 21 different nations – and four continental unions – at the first FIG Parkour World Cup to be held in Bulgaria in September 2021. Sofia, the Bulgarian capital, staged the competition from 9-12 September, with the action unfolding across a 40m course on the forecourt of the National Palace of Culture – a striking setting, symbolic of how a country with deeply rooted Gymnastics traditions has sought to promote this new urban sport. The World Cup served as a qualifier for the World Games 2022 and the spread of medallists sent an encouraging message about the breadth of talent in the discipline, with Sweden and France alone ending the competition with more than one medal. For Sweden, 17-year-olds Elis Torhall and Miranda Tibbling showcased the next generation with respective gold medals in the men’s Freestyle and women’s Speed competitions. France’s gold came in women’s Freestyle, through 18-year-old Lilou Ruel, who also finished second in the Speed final. Compared with that trio, Bohdan Kolmakov (UKR), the men’s Speed gold medallist, was a relative veteran at 23. In a year when Parkour’s planned World Championships were again postponed owing to the pandemic, the World Cup provided the sporting highlight and drew competitors from far and wide. Along with 15 European countries, there were athletes involved from Australia, Japan, Argentina, Chile, Colombia and Mexico. Javier Rodriguez Alvarez (MEX) was the sole nonEuropean medallist with his silver in the men’s Speed event.  GLOBAL SPREAD It is not just in Europe that national federations have embraced Parkour. A particularly encouraging example in 2021 came in Oceania where athletes and coaches formed the Oceania Gymnastics Union (OGU) Parkour Committee in March. The committee comprises representatives from Fiji (Peter Yee), New Zealand (Stephen Bruce van Huysen), Papua New Guinea (Karl Peter Giwi) and Australia  54  FIG YEARBOOK 2021  (Harrison Gabriel), with FIG Commission Member Ben Cork (AUS) as Chair. Through a series of monthly online meetings, they created a four-year strategic plan, the OGU Parkour Strategy which was unveiled in August. Emerging nations such as the Cook Islands, Guam and American Samoa attended the launch to hear about the plans and were joined by Charles Perriere (FRA) and Nicolas Fischer (SUI), representing the Parkour Commission. The committee is now working with member nations on development plans to promote engagement and participation, and already it has set up new education programmes and the first Continental Championships, due to take place in the coming year. OGU Secretary General Brooke Kneebush said: “We already have our first licensed FIG athletes and now we’re looking towards opportunities to build our local capacity in education for our coaches and events for our participants.”  21 nations represented at the Parkour World Cup  Above Ukraine’s Bodhan Kolmakov gets ahead of Britain’s David Nelmes on his way to men’s Speed gold"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/e4mCZLaAEv0')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:278px;top:529px\" src=\"/2021/static/_content/white-play.png\">\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "World Cups  Across the Pacific, the Pan American Gymnastics Union (PAGU) delivered an impressive range of online and inperson training and engagement in 2021. In April, coaches from Honduras, Venezuela, Panama, El Salvador, Costa Rica, and Colombia gathered for a Parkour Introductory Course run by PAGU Commission Member Benigno Moises Ramos Villanueva (MEX). PAGU also introduced online judge training in April to ensure accredited FIG judges across Pan-America. With local events growing, Venezuela held its first national Interclub Championships in August. In Asia, meanwhile, the decision by the Gymnastics Association of Hong Kong, China (GAHK) to formally endorse Parkour as a discipline in late 2020 led to further co-operation during 2021 between local Parkour coaches and athletes and existing GAHK coaches and administrators.  Sport  The Pan American Gymnastics Union (PAGU) delivered an impressive range of online and in-person training and engagement in 2021.  Left Sweden's Miranda Tibbling in Sofia, Bulgaria  FIG YEARBOOK 2021  55"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:840px;left:407px;width:205px;height:21px;\">\n        <a href=\"https://eurotramp.com\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "HIGH QUALITY IN MATERIAL, DESIGN AND COMPETITION SERVICE!  YOUR E VIC R E S L L FU R PARTNE ! ON SITE  Since 1960 we supplied countless national and international competitions with Eurotramp equipment. Olympic Games 2021 Tokyo, Japan (scheduled) 2016 Rio, Brasil 2008 Beijing, China 2004 Athens, Greece 2000 Sydney, Australia Youth Olympic Games 2018 Buenos Aires, Argentina 2010 Singapore, Republic of Singapore ... and many many more....  European Games 2019 Minsk, Belarus 2015 Baku, Azerbaijan  European Championships 2021 Sochi, Russia (scheduled) 2018 Baku, Azerbaijan 2016 Valladolid, Spain  World Championships 2021 Baku, Azerbaijan (scheduled) 2019 Tokyo, Japan 2018 St. Petersburg, Russia 2017 Sofia, Bulgaria 2015 Odense, Denmark  Continental Championships 2017 2016 2014 2012  Australian Gymnastics Championships Indo Pacific Champ., New Zealand Asian Games Incheon, Korea African Championships, South Africa  WWW.EUROTRAMP.COM"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:479px;left:328px;width:39px;height:40px;\">\n        <a href=\"https://www.facebook.com/fig.gym\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:687px;left:344px;width:39px;height:40px;\">\n        <a href=\"https://www.instagram.com/figymnastics\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Media & Marketing  Fan Engagement and Social Media  SOCIAL MEDIA: PLATFORMS FOR GROWTH A more creative, dynamic approach has brought the FIG a bigger social media following.  T  he FIG’s efforts to increase the size of its footprint on the social-media landscape were reflected, in 2021, by an impressive growth in followers of, and engagement with, its channels. For the FIG, this was reward for a strategy shift made in response to the shutdown of sporting activities caused by the COVID-19 pandemic in 2020. There was a significant rethink regarding the FIG’s digital communication efforts and greater investment in social media. Content-wise, the FIG showed agility and creativity, turning its focus away from the ‘Road to Tokyo’ campaign and towards historical events, athlete interviews and explanatory pieces on  the evolution of the sport. The team made use of a database of existing content and footage from previous FIG events, and also developed their relationship with the Olympic Channel to access footage from past Olympic Games. To celebrate the approaching Tokyo Games, the FIG opened its vault to relive magical Olympic moments from Athens 1896 to Rio 2016. Accompanied by clips produced in collaboration with the Olympic Channel, in-depth features unearthing the history of the sport were interspersed with interviews with Gymnastics icons past and present, including Kato Sawao, Peter Kovacs and Lori Fung.  Right The Philippines' Carlos Yulo in action in Kitakyushu, Japan  FIG on Facebook in 2021  372k new followers  169k new fans  45%  a increase  46%  a increase  FIG on Instagram in 2021  52k new followers  60  FIG YEARBOOK 2021  59%  a increase"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Fan Engagement and Social Media  Media & Marketing  These figures represent the grand total of all FIG social media channels during the Artistic and Rhythmic World Championships in Kitakyushu, Japan.  43m impressions  2.3m engagements  5.3m video views on YouTube  FIG YEARBOOK 2021  61"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Media & Marketing  Fan Engagement and Social Media  OLYMPICS AND WORLDS PROMPT PEAKS OF INTEREST Stories from Tokyo 2020 involving Simone Biles and the German Women’s Artistic Gymnastics team ranked among the most popular in 2021.  T  he FIG continued to expand its social-media following in 2021 with peaks of interest arriving in August during the Tokyo Olympics and in October during the Artistic Gymnastics World Championships. The decision of USA’s Simone Biles to withdraw from five finals in Tokyo – including the Team and women's Individual All-Around finals – to focus on her mental health drew a spike in activity on the FIG Facebook account. It was also one of the top three most popular posts of the year on the FIG’s Twitter account. According to an FIG media analysis, interest in Biles’s story also caused a surge in traffic on the governing body’s website with more than 350,000 users recorded in August. Biles’s withdrawal was the focus of 20% of the FIG’s online media mentions, meanwhile. Another story which had an impact on the increase in website traffic in August concerned the Germany Women’s Artistic Gymnastics’ team’s full-body leotards worn in Tokyo – offering a message against the sexualisation of female athletes. According to the media analysis, many articles and posts referred to the FIG’s official rules on attire, which leave the choice to the athletes on what is worn during competition. The possibility to wear unitards in competitions has been stated in the FIG rules for several years and in Rhythmic Gymnastics, for example, many gymnasts are already used to wearing full-legged leotards. The FIG is pleased to see that athletes make use of their option to choose the attire they feel the most comfortable wearing when they compete. Indeed, the prominence of  62  FIG YEARBOOK 2021  both this story and Biles’s mirrored the FIG’s aim for an athletes-first approach. The FIG’s Twitter activity peaked in October with the top posts by engagement relating to the success of Carlos Yulo (PHI), gold medallist in men’s Vault at the World Championships in Kitakyushu. The same went for Instagram with the top posts relating to Angelina Melnikova (RGF) who was the women’s All-Around champion. Website traffic rose again, meanwhile, owing both to interest in coverage of Fujitsu’s AI-powered 3D-sensing technology and athlete-centred articles on the World Championships.  Left USA's Simone Biles on Balance Beam in Tokyo, Japan Right Germany's Elisabeth Seitz on Uneven Bars"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"63-no1\" class=\"abs merriweather-bold 63-no\" style=\"left: 488px; top: 131px; font-size: 1.7em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 130.2, \"append\": \"k\", \"decimals\": 1}' ></h1>\n        <h1 id=\"63-no2\" class=\"abs merriweather-bold 63-no\" style=\"left: 488px; top: 204px; font-size: 1.7em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 52.3, \"append\": \"m\", \"decimals\": 1}' ></h1>\n        <h1 id=\"63-no3\" class=\"abs merriweather-bold 63-no\" style=\"left: 488px; top: 279px; font-size: 1.7em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 5.4, \"append\": \"m\", \"decimals\": 1}' ></h1>\n\n        <h1 id=\"63-no4\" class=\"abs merriweather-bold 63-no\" style=\"left: 82px; top: 618px; font-size: 0.75em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 828, \"append\": \"k\"}' ></h1>\n        <img class=\"halfScale 63-percentage-1\" style=\"top:618px;left:119px;\" src=\"/2021/static/_content/63-percentage-1.png\">\n\n        <h1 id=\"63-no5\" class=\"abs merriweather-bold 63-no\" style=\"left: 256px; top: 618px; font-size: 0.75em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 462, \"append\": \"m\"}' ></h1>\n        <img class=\"halfScale 63-percentage-2\" style=\"top:618px;left:298px;\" src=\"/2021/static/_content/63-percentage-2.png\">\n\n        <h1 id=\"63-no6\" class=\"abs merriweather-bold 63-no\" style=\"left: 437px; top: 618px; font-size: 0.75em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 34, \"append\": \"m\"}' ></h1>\n        <img class=\"halfScale 63-percentage-3\" style=\"top:618px;left:470px;\" src=\"/2021/static/_content/63-percentage-3.png\">\n\n\n        <h1 id=\"63-no7\" class=\"abs merriweather-bold 63-no\" style=\"left: 82px; top: 679px; font-size: 0.75em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 140, \"append\": \"k\"}' ></h1>\n        <img class=\"halfScale 63-percentage-4\" style=\"top:679px;left:119px;\" src=\"/2021/static/_content/63-percentage-4.png\">\n\n        <h1 id=\"63-no8\" class=\"abs merriweather-bold 63-no\" style=\"left: 256px; top: 679px; font-size: 0.75em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 98, \"append\": \"m\"}' ></h1>\n        <img class=\"halfScale 63-percentage-5\" style=\"top:679px;left:289px;\" src=\"/2021/static/_content/63-percentage-5.png\">\n\n        <h1 id=\"63-no9\" class=\"abs merriweather-bold 63-no\" style=\"left: 437px; top: 679px; font-size: 0.75em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 2.4, \"append\": \"m\", \"decimals\": 1}' ></h1>\n        <img class=\"halfScale 63-percentage-6\" style=\"top:679px;left:474px;\" src=\"/2021/static/_content/63-percentage-6.png\">\n\n\n        <h1 id=\"63-no10\" class=\"abs merriweather-bold 63-no\" style=\"left: 82px; top: 739px; font-size: 0.75em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 80.5, \"append\": \"k\", \"decimals\": 1}' ></h1>\n        <img class=\"halfScale 63-percentage-7\" style=\"top:739px;left:122px;\" src=\"/2021/static/_content/63-percentage-7.png\">\n\n        <h1 id=\"63-no11\" class=\"abs merriweather-bold 63-no\" style=\"left: 256px; top: 739px; font-size: 0.75em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 51, \"append\": \"m\"}' ></h1>\n        <img class=\"halfScale 63-percentage-8\" style=\"top:739px;left:287px;\" src=\"/2021/static/_content/63-percentage-8.png\">\n\n        <h1 id=\"63-no12\" class=\"abs merriweather-bold 63-no\" style=\"left: 437px; top: 739px; font-size: 0.75em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 2.8, \"append\": \"m\", \"decimals\": 1}' ></h1>\n        <img class=\"halfScale 63-percentage-9\" style=\"top:739px;left:473px;\" src=\"/2021/static/_content/63-percentage-9.png\">\n\n        <div class=\"addContentLink\" style=\"top:594px;left:26px;width:42px;height:62px;\">\n          <a href=\"https://www.facebook.com/fig.gym/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:653px;left:26px;width:42px;height:62px;\">\n          <a href=\"https://www.instagram.com/accounts/login/?next=/figymnastics/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:713px;left:26px;width:42px;height:62px;\">\n          <a href=\"https://twitter.com/gymnastics\" target=\"_blank\"></a>\n        </div>\n\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/gymnasticschannel')\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:357px;top:44px\" src=\"/2021/static/_content/white-play.png\">\n        </a>\n        \n      ",
    "script": "\n        function onPageEnter() {\n          pg63Anim = new TimelineMax();\n          pg63Anim.fromTo(cOf(\"63-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"63-no\")[0]);}}, 1)\n          .fromTo(cOf(\"63-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"63-no\")[1]);}}, 1.2)\n          .fromTo(cOf(\"63-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"63-no\")[2]);}}, 1.4)\n          .fromTo(cOf(\"63-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"63-no\")[3]);}}, 1.5)\n          .fromTo(cOf(\"63-percentage-1\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 2)\n          .fromTo(cOf(\"63-no\")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"63-no\")[4]);}}, 1.6)\n          .fromTo(cOf(\"63-percentage-2\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 2.1)\n          .fromTo(cOf(\"63-no\")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"63-no\")[5]);}}, 1.7)\n          .fromTo(cOf(\"63-percentage-3\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 2.2)\n          .fromTo(cOf(\"63-no\")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"63-no\")[6]);}}, 1.8)\n          .fromTo(cOf(\"63-percentage-4\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 2.3)\n          .fromTo(cOf(\"63-no\")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"63-no\")[7]);}}, 1.9)\n          .fromTo(cOf(\"63-percentage-5\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 2.6)\n          .fromTo(cOf(\"63-no\")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"63-no\")[8]);}}, 2)\n          .fromTo(cOf(\"63-percentage-6\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 2.5)\n          .fromTo(cOf(\"63-no\")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"63-no\")[9]);}}, 2.1)\n          .fromTo(cOf(\"63-percentage-7\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 2.6)\n          .fromTo(cOf(\"63-no\")[10], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"63-no\")[10]);}}, 2.2)\n          .fromTo(cOf(\"63-percentage-8\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 2.7)\n          .fromTo(cOf(\"63-no\")[11], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"63-no\")[11]);}}, 2.3)\n          .fromTo(cOf(\"63-percentage-9\"), 1, {opacity:0, x:30}, {opacity:1, x:0, ease: Power2.easeOut}, 2.8)\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 4000);\n        }\n\n        function onPageLeave() {\n          pg63Anim.stop();\n          resetNumbers(\"63-no\")\n          removeContentLinks()\n        }\n      ",
    "searchText": "Fan Engagement and Social Media  Media & Marketing  YouTube  130.2k new subscribers  52.3m views  5.4m  ON THE RISE  Followers  engagements  The FIG YouTube channel’s most-watched video in 2021 was the Individual Apparatus Finals at the Artistic Gymnastics World Championships on 24 October.  Impressions  Engagements  828k (+45%)  462m (+105%)  34m (+147%)  140k (+59%)  98m (+184%)  2.4m (+163%)  80.5k (+18%)  51m (+379.3%)  2.8m (+616.7%)  Source: FIG social media platforms with data generated from 1 January 2021 to 31 December 2021, compared to 2020  FIG YEARBOOK 2021  63"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Media & Marketing  TV  THE GLOBAL PICTURE Gymnastics has more visibility than ever on TV screens worldwide as a new broadcast cycle began in 2021.  E  xpanding the global reach of Gymnastics is essential to the work of the FIG. This work involves commercialising media rights, managing broadcast partners and – through on-site and remote production teams – delivering high-quality Gymnastics content to fans of the sport across the world. With the start of a new cycle running until 2024, 2021 witnessed a greater global reach than ever with viewers in more than 100 countries benefitting from key broadcast deals which commenced in Europe with the European Broadcast Union (EBU), in the United States with NBC, in China with CCTV, and in Japan with TV Asahi.  64  FIG YEARBOOK 2021  To highlight just one example, the deal for EBU members secures free-to-air TV coverage of events across 57 territories in Europe and North Africa from 2021 to 2024, bringing increased visibility and viewer engagement. In those countries without broadcast deals, meanwhile, FIG events were live-streamed on the FIG YouTube channel as well as the Olympic Channel."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScaleC 65-icon-1\" style=\"top:27px; left:423px;\" src=\"/2021/static/_content/65-icon-1.png\">\n\n      <h1 id=\"65-no1\" class=\"abs merriweather-bold 65-no\" style=\"left: 498px; top: 189px; font-size: 2em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 100}' ></h1>\n      \n      <img class=\"halfScale 65-text-1\" style=\"top:223px;left:480px;\" src=\"/2021/static/_content/65-text-1.png\">\n\n\n      <img class=\"halfScaleC 65-icon-2\" style=\"top:260px; left:423px;\" src=\"/2021/static/_content/65-icon-2.png\">\n\n      <h1 id=\"65-no2\" class=\"abs merriweather-bold 65-no\" style=\"left: 485px; top: 427px; font-size: 2em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 1170, \"comma\": true}' ></h1>\n\n      <img class=\"halfScale 65-text-2\" style=\"top:466px;left:479px;\" src=\"/2021/static/_content/65-text-2.png\">\n\n      <img class=\"halfScaleC 65-icon-3\" style=\"top:520px; left:423px;\" src=\"/2021/static/_content/65-icon-3.png\">\n\n      <h1 id=\"65-no3\" class=\"abs merriweather-bold 65-no\" style=\"left: 496px; top: 683px; font-size: 2em; font-weight:300; margin:0; color:#ffffff; padding:0; margin:0;\"  data-number='{\"to\": 259}' ></h1>\n\n      <img class=\"halfScale 65-text-3\" style=\"top:721px;left:479px;\" src=\"/2021/static/_content/65-text-3.png\">\n\n      <div class=\"addContentLink\" style=\"top:513px;left:32px;width:210px;height:131px;\">\n        <a href=\"https://olympics.com/en/search/all/All%20around\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg65Anim = new TimelineMax();\n          pg65Anim.fromTo(cOf(\"65-icon-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"65-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"65-no\")[0]);}}, 1.1)\n          .fromTo(cOf(\"65-text-1\"), 1, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, 1.4)\n          .fromTo(cOf(\"65-icon-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.6)\n          .fromTo(cOf(\"65-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"65-no\")[1]);}}, 1.7)\n          .fromTo(cOf(\"65-text-2\"), 1, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, 2)\n          .fromTo(cOf(\"65-icon-3\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2.2)\n          .fromTo(cOf(\"65-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"65-no\")[2]);}}, 2.3)\n          .fromTo(cOf(\"65-text-3\"), 1.1, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: flashContentLinksThreeTimes}, 2.6)\n        }\n\n        function onPageLeave() {\n          pg65Anim.stop();\n          resetNumber(\"65-no\")\n          removeContentLinks();\n      }\n      ",
    "searchText": "TV  Media & Marketing  100  nations  More than 100 nations guaranteed free-to-air Gymnastics coverage in the 2021-24 cycle  1,170 hours  TV coverage across the  KEY COLLABORATIONS For the Artistic, Rhythmic and Trampoline Gymnastics World Championships held in 2021, the FIG and its partners provided over 1,100 hours of television coverage. This involved working together with Spring Media, which for the first time had a production team at each of the World Championships and created additional content such as behind-the-scenes footage, interviews and highlights packages.  The FIG’s collaboration with the Olympic Channel went from strength to strength, meanwhile. The Olympic Channel, with its access to the IOC archive, is crucial in providing video clips and photographs to accompany digital content on the FIG website. The postponement of the Tokyo 2020 Olympic Games caused by the pandemic prompted an even closer co-operation: rather than seek to build momentum over a period of months, the focus shifted to story-telling over more than a year. Hence, for example, the providing of video clips for different types of features: from features on past Olympic Games or Gymnastics legends to articles explaining specific apparatus or elements. Another success was the Olympic Channel’s All Around series, which followed three Artistic gymnasts – Morgan Hurd (USA), Chen Yile (CHN) and Angelina Melnikova (ROC) – behind the scenes. Planned as a 12-month series leading to the originally scheduled start date of Tokyo 2020, it continued into 2021.  2021 Artistic, Rhythmic and Trampoline Gymnastics World Championships  259  million+ TV viewers Above excerru Cumulative TV viewers piendundania across the 2021 Artistic, nonseorest liaand Rhythmic Trampoline Gymnastics excerru piendunduc World Championships ipsania nonse  FIG YEARBOOK 2021  65"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:137px;left:52px;width:77px;height:62px;\">\n        <a href=\"https://olympics.com/en/olympic-channel\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:357px;left:332px;width:97px;height:51px;\">\n        <a href=\"https://springmedia.se/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Media & Marketing  TV  John Palfrey, Olympic Channel “We started working with the FIG in the lead-up to Tokyo, when the idea was to have a few videos relating to past Olympic champions to create momentum before the Games. Because of the postponement of the Games, it became a huge project – instead of a few weeks we did it for over a year and so broadened the number of topics and themes covered. “The FIG has the knowledge in terms of their sport and we have access to the Olympic archive. We mix both Olympic footage and FIG footage to tell a story – be it of a legend or an apparatus. Since Tokyo 2020 we’ve had other federations come to see us and say, ‘You’re doing a great job with the FIG, we’d like to do the same kind of long-term project with our own sport’.”  66  FIG YEARBOOK 2021  Jose Moreno, Spring Media “With the pandemic making it difficult for companies to be working on site at events, we have increasingly employed our remote production facilities during the past couple of years. These production and postproduction facilities are based in Riga (LAT) and together with our StayLive platform, a digital platform for video and livestreaming, we produce and deliver content for the FIG. We produce highlights from events, using the world feed that is produced by each host broadcaster. We have a TV co-ordinator on site at the FIG World Cup events – for the Olympic disciplines only – to make sure we get the quality we need from the host broadcasters. Throughout the year we co-ordinate with the LOCs and host broadcasters for them to follow the broadcast manual which we produce annually with the FIG. This co-ordination began in 2017. “In 2021, for the first time, we had an on-site production team at all the FIG World Championships. We sent a producer and cameraman and this way we could produce additional content outside of the competition – more appealing content for fans such as interviews and highlights. In Kitakyushu, for example, we produced these with a small editing crew on site and using the remote facilities as well.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:813px;left:115px;width:203px;height:21px;\">\n        <a href=\"mailto:admin@gaofeisports.com\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:835px;left:387px;width:191px;height:21px;\">\n        <a href=\"https://gaofeisports.com\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/AePgZoP9Q14')\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:537px;top:596px\" src=\"/2021/static/_content/white-play.png\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Media & Marketing  Media Operations  A WINDOW FOR THE WORLD’S MEDIA The Virtual Media Centre enabled the international press to produce dedicated coverage of two FIG World Championships remotely.  68  FIG YEARBOOK 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"69-no1\" class=\"abs merriweather-bold 69-no\" style=\"left: 483px; top: 187px; font-size: 2em; font-weight:300; margin:0; color:#e73b1f; padding:0; margin:0;\"  data-number='{\"to\": 45, \"append\": \"%\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg69Anim = new TimelineMax();\n          pg69Anim.fromTo(cOf(\"69-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"69-no\")[0]);}}, 1)\n        }\n\n        function onPageLeave() {\n          pg69Anim.stop();\n          resetNumbers(\"69-no\")\n        }\n      ",
    "searchText": "Media Operations  Media & Marketing  M  ore than 400 media members from 25 countries were accredited for the FIG Artistic and Rhythmic World Championships in Kitakyushu, Japan. The pandemic meant adapting media operations, with remote facilities required to enable athlete interview opportunities. The Virtual Media Centre (VMC) was the name of the technological innovation which provided the solution, ensuring full global media coverage of both events. In the face of the international travel restrictions prompted by the coronavirus pandemic, the FIG joined forces with the local organising committee and FIG Broadcast Partner Eurovision Sport (EBU), to create a ground-breaking solution for these two major World Championships in October 2021. The VMC allowed worldwide media to produce dedicated coverage of the action despite not being based in Kitakyushu, in working conditions as close as possible to being at the championships. The EBU had previously used a VMC at the European Athletics Indoor Championships in March 2021 and for the FIG it proved an excellent resource. Accredited international press were able to watch all the live action on this browser-based platform – from both the international feed and isolated cameras – as well as to access all  45% Percentage of accredited media members who worked remotely 'in' the VMC across the two World Championships in Kitakyushu  Left USA’s Leanne Wong  RUNNING A VMC How the FIG enabled full media coverage from afar  Remote mixed zone operations  Live screening of each event, including qualifying  Live results provided by FIG IT team  Live flash interviews  Recorded press conferences and flash interviews  Event information e.g. competition schedule, entry lists, start lists, results  Media banks, photo galleries and picture requests  FIG YEARBOOK 2021  69"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Media & Marketing  Media Operations  the content that would normally be available in the physical media centre at international sport events. This included access to flash interviews, which were carried out on site in the Broadcast Mixed Zone by an FIG Communications team member. These interviews were streamed live in the VMC and later made available for viewing and download. There were opportunities for interviews for those press working remotely too: at the Rhythmic Gymnastics World Championships, for instance, 30 interviews took place in the virtual mixed zone over the five days of the event. In total, 85 of the 137 journalists working on the Artistic Gymnastics World Championships covered the event remotely. For the Rhythmic  70  FIG YEARBOOK 2021  Gymnastics World Championships, the number was 58 of an overall written press contingent of 94. While the TV broadcast coverage of the two World Championships was limited to the finals only, journalists accessing the online platform were able to follow the qualifying action too. This was thanks to the FIG’s instant replay control system (IRCOS) that entails a camera on every single apparatus. The signals from these isolated cameras were made available to accredited media using the VMC during the Artistic Gymnastics World Championships so that they could follow events on each apparatus. Every camera signal on the online platform was made available, and media were able to follow their athletes on whichever apparatus they were performing.  Below Brazil's Rebeca Andrade faces the media in Kitakyushu, Japan"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:843px;left:28px;width:145px;height:18px;\">\n        <a href=\"https://gymnova.com\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "P A S S I O N  PHOTO © FRANCK FAIPOT - DESIGN ZEN-STUDIO.COM (MARSEILLE)  A  PARTNER TO MAJOR EVENTS IN 2022  WWW.GYMNOVA.COM  F O R  G Y M N A S T I C S"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top:772px;left:341px;width:37px;height:12px;\" onclick=\"Publish.goToPage(102)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Media & Marketing  Marketing and Sponsors  WORKING TOGETHER FOR TOMORROW The FIG receives support in promoting Gymnastics from several key partners and has begun a major market research project to learn more about its audience.  T  he FIG’s marketing activities are focused around sponsorship sales, partnership, account and brand management, licensing and market research. In 2021, the FIG continued to work closely with its established global partners, Fujitsu and VTB, and signed a one-year renewal deal with Tokio Inkarami. A leading professional haircare brand, Tokio Inkarami has been a supporter of the FIG since 2019, helping in particular to promote Rhythmic Gymnastics.  As for Fujitsu, a partner since 2017, it is striving to help Gymnastics gain from technological advancements, notably with its ground-breaking work in AI innovation (see section below). Owing to the impact of the pandemic on the competition calendar, the past two years have provided a series of challenges and, with certain 2020 events rescheduled to 2021, some sponsorship agreements were extended.  Fujitsu and 3D-sensing technology* President Watanabe highlighted the farreaching, and potentially positive, implications for Gymnastics of 3D-sensing technology when he opened a webinar on the subject in September 2021. Developed by engineers from the FIG’s global partner Fujitsu, the “robot judging” support system, based on 3D-sensing Artificial Intelligence Technology that consists of a camera equipped with a 3D sensor, captures a gymnast’s movements and transmits images and data to a computer that projects a graphic 3D image of the gymnast’s performance.  72  FIG YEARBOOK 2021  The data recorded by cameras is analysed by AI, which uses the gymnast’s posture, position in relation to the apparatus and type of movement to determine the element the gymnast is performing. After extensive research and development conducted by Fujitsu at the past three World Championships and the 2019 Junior World Championships in Artistic Gymnastics, the system is able to recognise more than 800 elements in Men’s Artistic Gymnastics and more than 500 elements in Women’s Artistic Gymnastics.  *See p102-103 in the Institutional section for more details.  Above Kita Sumire's performance earned her Tokio Inkarami's Prize for Style at the Rhythmic Gymnastics World Championships"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScaleC 73-icon-1\" style=\"top:672px; left:83px;\" src=\"/2021/static/_content/73-icon-1.png\">\n      \n      <img class=\"halfScale 73-text-1\" style=\"top:772px;left:65px;\" src=\"/2021/static/_content/73-text-1.png\">\n\n      <img class=\"halfScaleC 73-icon-2\" style=\"top:672px; left:262px;\" src=\"/2021/static/_content/73-icon-2.png\">\n\n      <img class=\"halfScale 73-text-2\" style=\"top:772px;left:252px;\" src=\"/2021/static/_content/73-text-2.png\">\n\n      <img class=\"halfScaleC 73-icon-3\" style=\"top:672px; left:437px;\" src=\"/2021/static/_content/73-icon-3.png\">\n      \n      <img class=\"halfScale 73-text-3\" style=\"top:772px;left:432px;\" src=\"/2021/static/_content/73-text-3.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg73Anim = new TimelineMax();\n          pg73Anim.fromTo(cOf(\"73-icon-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"73-text-1\"), 1, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"73-icon-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.4)\n          .fromTo(cOf(\"73-text-2\"), 1, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, 1.6)\n          .fromTo(cOf(\"73-icon-3\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.8)\n          .fromTo(cOf(\"73-text-3\"), 1.1, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, 2)\n        }\n\n        function onPageLeave() {\n          pg73Anim.stop();\n      }\n      ",
    "searchText": "Marketing and Sponsors  Media & Marketing  Eye on the future  Future projects include ambitious plans to:  Innovate and modernise rights offering to existing and potential partners, increasing brand-activation opportunities  Introduce standardised branding guidelines and assets to all our partners to raise FIG brand awareness  Launch relevant marketing and digital campaigns to raise engagement and to grow our fan base  FIG YEARBOOK 2021  73"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Media & Marketing  Marketing and Sponsors  SPONSOR ACTIVITIES  Above left Tokio Inkarami Prize for Style presentation to Kita Sumire; (right) Japan's men receive the Fujitsu Infinity Award Bottom right Japan's Hashimoto Daiki  74  FIG YEARBOOK 2021  Despite challenges in rights delivery during the pandemic, the FIG was able to work with its partners in 2021 on successful activations at the World Championship events in Kitakyushu – for Artistic Gymnastics and Rhythmic Gymnastics – and in Baku, for Aerobic Gymnastics. At the Japanet Artistic Gymnastics World Championships, Fujitsu presented a new Fujitsu Infinity Award which honoured a national federation in both Men’s and Women’s Artistic Gymnastics for their achievements. Federations were selected based on results, artistic merit and virtuosity in performance, as well as challenges overcome.  A committee including President Watanabe, event ambassadors Svetlana Khorkina (WAG) and Takuji Hayata (MAG), and representatives from Fujitsu selected the winners, who received a trophy and shared a USD $10,000 total cash prize, with the inaugural prizes going to the Japanese men and the RGF women. President Watanabe presented the men’s award while Fujitsu CEO Takahito Tokita presented the prize to the women. The Aeon Rhythmic Gymnastics World Championships featured the new Tokio Inkarami Prize for Style, which was presented to the athlete deemed most stylish at the championships and came accompanied by a USD $5,000 cash prize and a gift package. Kita Sumire"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Marketing and Sponsors  Media & Marketing  (JPN) received the trophy from Tokio Inkarami CEO Fuyuhiro Masanao and event ambassador Evgeniya Kanaeva following the Individual All-Around final. Finally, the VTB Prize for Accuracy was a new award at the Aerobic Gymnastics World Championships. Precision and accuracy were among the qualities evaluated by the jury. The Individual Women’s World champion, Ayse Onbasi (TUR), and men’s silver medallist Roman Semenov (RGF) took the inaugural USD $5,000 prizes.  FIG YEARBOOK 2021  75"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "\n\n      <h1 id=\"76-no1\" class=\"abs merriweather-bold 76-no\" style=\"left: 472px; top: 469px; font-size: 2em; font-weight:300; margin:0; color:#e73b1f; padding:0; margin:0;\"  data-number='{\"to\": 68, \"append\": \"%\"}' ></h1>\n      \n      <img class=\"halfScale 76-text-1\" style=\"top:513px;left:473px;\" src=\"/2021/static/_content/76-text-1.png\">\n\n\n      <h1 id=\"76-no2\" class=\"abs merriweather-bold 76-no\" style=\"left: 472px; top: 567px; font-size: 2em; font-weight:300; margin:0; color:#e73b1f; padding:0; margin:0;\"  data-number='{\"to\": 35, \"append\": \"%\"}' ></h1>\n\n      <img class=\"halfScale 76-text-2\" style=\"top:610px;left:473px;\" src=\"/2021/static/_content/76-text-2.png\">\n\n\n      <h1 id=\"76-no3\" class=\"abs merriweather-bold 76-no\" style=\"left: 472px; top: 663px; font-size: 2em; font-weight:300; margin:0; color:#e73b1f; padding:0; margin:0;\"  data-number='{\"to\": 86, \"append\": \"%\"}' ></h1>\n\n      <img class=\"halfScale 76-text-3\" style=\"top:708px;left:473px;\" src=\"/2021/static/_content/76-text-3.png\">\n\n\n      <h1 id=\"76-no3\" class=\"abs merriweather-bold 76-no\" style=\"left: 472px; top: 750px; font-size: 2em; font-weight:300; margin:0; color:#e73b1f; padding:0; margin:0;\"  data-number='{\"to\": 89, \"append\": \"%\"}' ></h1>\n\n      <img class=\"halfScale 76-text-4\" style=\"top:795px;left:473px;\" src=\"/2021/static/_content/76-text-4.png\">\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg76Anim = new TimelineMax();\n          pg76Anim.fromTo(cOf(\"76-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"76-no\")[0]);}}, 1)\n          .fromTo(cOf(\"76-text-1\"), 1, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"76-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"76-no\")[1]);}}, 1.3)\n          .fromTo(cOf(\"76-text-2\"), 1, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, 1.3)\n          .fromTo(cOf(\"76-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"76-no\")[2]);}}, 1.6)\n          .fromTo(cOf(\"76-text-3\"), 1.1, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut}, 1.6)\n          .fromTo(cOf(\"76-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"76-no\")[3]);}}, 1.9)\n          .fromTo(cOf(\"76-text-4\"), 1.1, {opacity:0, y:30}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: flashContentLinksThreeTimes}, 1.9)\n        }\n\n        function onPageLeave() {\n          pg76Anim.stop();\n          resetNumber(\"76-no\")\n          removeContentLinks();\n      }\n      ",
    "searchText": "Media & Marketing  Audience  UNDERSTANDING OUR AUDIENCE The FIG embarked on an ambitious long-term market research project to build a database of key statistics and it began by collecting audience insights for each of the Gymnastics disciplines through social media users and their interests.  W  ith its Global Online Review, the FIG achieved a breakdown of the gender and age of the audience for each discipline. The full breakdown is in the table below but significant findings included:  • Artistic: the closest balance between the genders with a split of 55% female and 45% male • Rhythmic: the largest share of young fans with 28% in the 13-17 age bracket • Trampoline: the biggest percentage of fans from the 35-44 age bracket (17%) • Parkour: the highest share of fans aged 18-24 (58%) • Of all the disciplines, only Parkour (89%) and Trampoline (67%) have more male fans than female  68%  Gymnastics  32%  Gender split  55%  Artistic  45%  88%  Rhythmic  76  FIG YEARBOOK 2021  12%  13 - 17 18 - 24 25 - 34 35 - 44 45 - 54 55range + Age 13 - 17 18 - 24 25 - 34 35 - 44 45 - 54 55 + 13 - 17 18 - 24 25 - 34 35 - 44 45 - 54 55 +  Female Gymnastics fans form the majority  17% 35% 18% 15% 10% 5%  35% Percentage of Gymnastics fans aged between 18-24  16% 33% 29% 11% 8% 3%  86% Percentage of female Rhythmic fans  28% 31% 30% 7% 4% >1%  68%  89% Percentage of male Parkour fans"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Gender split  33%  Trampoline  67%  71%  Acrobatic  29%  74%  Aerobic  26%  11%  Parkour  89%  Age range 13 - 17 18 - 24 25 - 34 35 - 44 45 - 54 55 + 13 - 17 18 - 24 25 - 34 35 - 44 45 - 54 55 + 13 - 17 18 - 24 25 - 34 35 - 44 45 - 54 55 + 13 - 17 18 - 24 25 - 34 35 - 44 45 - 54 55 +  13% 37% 22% 17% 8% 3% 10% 49% 15% 12% 11% 3% 9% 39% 30% 12% 6% 4% 15% 58% 16% 5% 4% 2%  FIG YEARBOOK 2021  77"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:834px;left:165px;width:279px;height:32px;\">\n        <a href=\"http://www.pastorellisport.com/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top: 844px;left: 223px;width: 184px;height: 20px;\">\n          <a href=\"http://www.sasaki-sports.co.jp/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Institutional"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:614px;left:90px;width:245px;height:17px;\">\n        <a href=\"https://www.gymnastics.sport/site/governance.php\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Institutional  Governance  Below excerru piendundania nonseorest lia excerru piendduc ipsania nonse  RAISING STANDARDS The FIG continues to take important steps forward in the area of good governance, integrity and transparency.  A  s the world governing body for Gymnastics, the FIG has an ongoing commitment to demonstrating an exemplary standard of governance throughout its structure and processes. This involves striving to reinforce or enhance its rules and regulations to adapt to the challenges of the times we live in. In recent years, the FIG has taken significant strides forward in areas such as integrity and development as well as transparency. To give one example, in 2019, it established the Gymnastics Ethics  82  FIG YEARBOOK 2021  Foundation (GEF) as an independent, adjudicatory body to which any wrongdoing or incidents could be reported. To underline the commitment to good governance, at the 2021 FIG Congress delegates decided in principle to start a revision process aimed at overhauling the structure of the Statutes – specifically by altering the wording to make the rules easier to understand for a large number of people and thereby better meet the standards of good practice and good governance.  The FIG has an ongoing commitment to demonstrating an exemplary standard of governance"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScaleC 83-text\" style=\"top:693px; left:41px;\" src=\"/2021/static/_content/83-text-1.png\">\n        <img class=\"halfScaleC 83-text\" style=\"top:713px; left:52px;\" src=\"/2021/static/_content/83-text-2.png\">\n        <img class=\"halfScaleC 83-text\" style=\"top:734px; left:46px;\" src=\"/2021/static/_content/83-text-3.png\">\n        <img class=\"halfScaleC 83-text\" style=\"top:753px; left:42px;\" src=\"/2021/static/_content/83-text-4.png\">\n        <img class=\"halfScaleC 83-text\" style=\"top:773px; left:27px;\" src=\"/2021/static/_content/83-text-5.png\">\n        <img class=\"halfScaleC 83-text\" style=\"top:793px; left:59px;\" src=\"/2021/static/_content/83-text-6.png\">\n\n        <img class=\"halfScaleC 83-number\" style=\"top:695px; left:344px;\" src=\"/2021/static/_content/83-number-1.png\">\n        <img class=\"halfScaleC 83-number\" style=\"top:715px; left:344px;\" src=\"/2021/static/_content/83-number-2.png\">\n        <img class=\"halfScaleC 83-number\" style=\"top:736px; left:344px;\" src=\"/2021/static/_content/83-number-3.png\">\n        <img class=\"halfScaleC 83-number\" style=\"top:755px; left:344px;\" src=\"/2021/static/_content/83-number-4.png\">\n        <img class=\"halfScaleC 83-number\" style=\"top:775px; left:344px;\" src=\"/2021/static/_content/83-number-5.png\">\n        <img class=\"halfScaleC 83-number\" style=\"top:795px; left:344px;\" src=\"/2021/static/_content/83-number-6.png\">\n\n        <div class=\"addContentLink\" style=\"top:478px;left:85px;width:120px;height:57px;\">\n          <a href=\"https://www.gymnasticsethicsfoundation.org/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:478px;left:244px;width:60px;height:57px;\">\n          <a href=\"https://www.asoif.com/member/f%C3%A9d%C3%A9ration-internationale-de-gymnastique \" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg83Anim = new TimelineMax();\n          pg83Anim.staggerFromTo(cOf(\"83-text\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1)\n          .staggerFromTo(cOf(\"83-number\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.2)\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 2000);\n        }\n\n        function onPageLeave() {\n          pg83Anim.stop();\n          removeContentLinks();\n      }\n      ",
    "searchText": "Governance  Institutional  ASOIF MEASURING PERFORMANCE The FIG can already point to tangible evidence of its improved performance in the area of governance – in the form of the Review of International Federation Governance by the Association of Summer Olympic International Federations (ASOIF). Across the three assessments undertaken by 2021 by ASOIF, the FIG has achieved a steady improvement: from a score of 77 out of 200 in 2016/17 to 98 in 2017/18 and then up to 132 in 2019/20. It was completing a fourth questionnaire as 2021 came to an end. The ASOIF assessment looks at five categories: transparency (see the financial reports on the website), integrity, democracy, development, and control mechanisms. In the evaluation submitted in 2020, the FIG achieved an increase of 34 in its overall score with improvements in many of the areas covered in the questionnaire. In doing so it comfortably exceeded the target of 120 set by the ASOIF Governance Task Force.  Compared to the other international federations which compete in the Summer Olympics, the FIG is in the third tier of four. Yet it is worth noting the apparent correlation between international federations with more revenue and a higher overall moderated score. In this context, the FIG was mid-placed when compared with other federations with a similar staff number.  BEACON OF PROGRESS The FIG has already taken a noteworthy step forward in the creation of the GEF. The FIG is determined to place gymnasts’ safety and well-being at the centre of its decisions, to ensure transparency, to avoid any conflicts of interests and to defend the integrity of the sport.  STEPPING UP  The ASOIF evaluation comprises a score of 40 for each of the following categories – with the FIG achieving a marked improvement to date in all areas:  2016/17  2017/18  2019/20  Transparency  21  22  30  Integrity  10  15  28  Democracy  20  24  25  Development  7  16  25  Control mechanisms  19  21  24  Total  77  98  132  Hence the establishing of the foundation in 2019 to ensure a clearer separation of powers via this professional and independent entity. By the middle of 2021, the president of the GEF, Micheline Calmy-Rey, reported on its activities during its first two full years of operation. In this time the GEF had registered 62 cases, 38 of which were related to safeguarding issues. As the GEF becomes better known, it anticipates that the number of cases will increase.  FIG ANNUAL FIG YEARBOOK REPORT2021 2021  83 83"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:617px;left:197px;width:88px;height:13px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/about-foundation.php\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Institutional  Measures during Pandemic  A HELPING HAND The FIG has shown solidarity and flexibility in its response to the unprecedented challenge of the COVID-19 pandemic.  “S  olidarity and friendship” were the values that President Watanabe cited when the FIG launched a Solidarity COVID-19 fund following the early months of the coronavirus pandemic. That was in May 2020 when this special fund was set up to provide financial assistance to athletes affected by the COVID-19 pandemic and national Gymnastics federations severely hit by the economic repercussions of the crisis. To sum up the total amount of support provided, by the end of 2021 the fund had covered 29 requests from 26 national federations. More than CHF 300,000 has been distributed in support grants and this support has proved vital in helping member federations who, because of  84  FIG YEARBOOK 2021  AFRICA (UAG) 9  PANAMERICA (PAGU) 6  EUROPE (EG) 6 ASIA (AGU) 5  COVID-19 Fund distribution: national federations which received support"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 84,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg85.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Measures during Pandemic  the financial impact of the pandemic, have found themselves without the funds to pay for coaches and facilities. The fund has been managed by the FIG Foundation for Solidarity. Since its inception in 2002, the foundation has supported hundreds of athletes and federations in need through scholarships, financial aid following an accident or a natural disaster, and equipment donations. The pandemic presents one of its biggest challenges yet. As well as solidarity, the FIG has shown flexibility too in these testing times. For instance, since the pandemic began, those continental unions who receive yearly contributions for their development funds have been allowed to hold on to their contributions despite not having  Institutional  been able to carry out any activities. Instead, they have been able to use the money on the resumption of Gymnastics activities. Additionally, in 2020, President Watanabe proposed to the Executive Committee to lift the obligation for member federations to pay their annual affiliation fee. Those who had already paid were reimbursed. In total this represented a sum CHF 120,000 for the FIG. Meanwhile, owing to the cancellation or postponement of the large majority of competitions in 2020, all gymnasts’ licences created or renewed between 1 January 2020 and 31 December 2020 were automatically renewed for a further 12 months free of charge. The same approach applied in 2021.  FIG YEARBOOK 2021  85"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 85,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg86.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 86,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg87.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/wkQUo8FuSNo')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:480px;top:346px\" src=\"/2021/static/_content/white-play.png\">\n      </a>\n\n      <div class=\"addContentLink\" style=\"top:168px;left:63px;width:438px;height:34px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/safeguarding.php\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:203px;left:63px;width:276px;height:34px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/safeguarding.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:250px;left:86px;width:88px;height:14px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/safeguarding-goldenrules.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:614px;left:298px;width:248px;height:12px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/safeguarding-goldenrules.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:748px;left:527px;width:14px;height:12px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/safeguarding-goldenrules.php\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:759px;left:484px;width:55px;height:12px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/safeguarding-goldenrules.php\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Safeguarding  Institutional  MAKING GYMNASTICS SAFE FOR ALL The 10 Golden Rules awareness campaign offered a fresh set of principles to guarantee a safe training environment for every gymnast.  I  t was the fruit of 12 months of consultations involving athletes, coaches and officials and the end product was a clear message for all involved in our sport – that there is no place for the old, harmful training methods of the past. This was the purpose of the 10 Golden Rules of Gymnastics, a collection of key principles created by the Gymnastics community for the Gymnastics community, which was unveiled in October 2021. It formed the centrepiece of an awareness campaign which ran on the FIG’s social media accounts and at the Artistic and Rhythmic Gymnastics World Championships in Kitakyushu, Japan. The presence of a cartoon cat, on posters and in the animated clips which accompanied the campaign, helped draw the focus of the youngest members of our community though, from the bottom to the top of the Gymnastics pyramid, the FIG encouraged everyone to take part. When sport came to a pause, gymnasts took to social media to open up about how training methods and mentalities dating from generations past had had a negative impact on their enjoyment of and passion for their sport. Some had suffered abuse, others mistreatment. These brave testimonies were significant in creating a better understanding of problems faced and they contributed towards the push for positive change in the Gymnastics community. It was the cue for further listening by the governing body. In late October 2020, the FIG invited national Gymnastics federations and other stakeholders to an online conference with the aim of finding solutions and sharing positive experiences and good  Check out the 10 Golden Rules awareness campaign here: www.gymnastics.sport/site/pages/safeguarding-goldenrules.php  practices which could be easily replicated around the world for the sake of better athlete welfare. In total, more than 800 representatives from around 80 federations took part. At this conference, the FIG committed to developing a new and robust legal framework to draw a clear line between what is acceptable and what is intolerable in training or competition halls. These principles would be summarised in an awareness campaign which illustrated the key principles in drawings.  Above The 10 Golden Rules are easy to access via social media, YouTube and the FIG website  FIG YEARBOOK 2021  87"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 87,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg88.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Institutional  Safeguarding  SAFEGUARDING UNIT The FIG’s Safeguarding Unit acts like a taskforce within the FIG, fulfilling a range of tasks:  Ensuring the implementation of the FIG framework for safeguarding athletes and other participants from harassment and abuse during events. A safeguarding officer at each World Championships plays a fundamental role – and this task is undertaken by the FIG Athletes’ Representative for the concerned discipline.  Providing services to the national federations. This includes assistance on request, and strengthening the FIG Statutes to encourage worldwide information exchange.  Developing educational materials, e.g., the 10 Golden Rules of Gymnastics awareness campaign, and the compulsory safeguarding lesson included in the FIG Academy Programme for coaches.  88  FIG YEARBOOK 2021  The end product was a clear message: there is no place for the old, harmful training methods of the past."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 88,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg89.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:139px;left:76px;width:204px;height:15px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/safeguarding.php\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Safeguarding  Institutional  SAFEGUARDING WORKING GROUP The FIG’s Safeguarding Working Group was set up in 2021 as part of the governing body’s commitment to effect a positive cultural change. The group comprises members from a diverse range of backgrounds, some of them still active gymnasts and others involved in the sport at other levels. Overall, 13 countries were represented in the initial cohort: Argentina, Australia, Canada, Denmark, France, Greece, Iran, Israel, Jordan, Mexico, New Zealand, Slovenia and Uruguay. The group is chaired by Donatella Sacchi, the President of the Women’s Artistic Gymnastics Technical Committee. It is an open group, meaning that people with different areas of expertise are invited to participate depending on the topics in question.  CARTOON WITH A SERIOUS MESSAGE The 10 Golden Rules came from the Gymnastics community itself. These are basic principles that were raised repeatedly and at different levels. Several athletes expressed these ideas in their testimonies on social networks. They were also put forward during the e-conference. In countries where numerous allegations of abuse have led to independent inquiries, these same principles were among the recommendations. Athletes, coaches and officials were asked to give feedback on early drafts. Then, from June 2021 onwards, the FIG looked to the newly established Safeguarding Working Group to finetune the ideas and wording for the campaign ahead of its launch. To illustrate the rules, the FIG worked with Swiss cartoonist Zep, whose drawing style appeals to young audiences. He created a character that is easy to identify with. The motion designer Sophie Borloz made a set of 10 eight-second animated clips that could be shared easily on social media. The design conveyed a clear message with cartoons to catch the eye and concise statements. It has since been reproduced in 22 other languages.  FIG YEARBOOK 2021  89"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 89,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg90.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Institutional  90  Gender Equality  FIG YEARBOOK 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 90,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg91.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 91-quote-1\" style=\"top:412px;right:-34px;\" src=\"/2021/static/_content/91-quote-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg91Anim = new TimelineMax();\n          pg91Anim.fromTo(cOf(\"91-quote-1\"), 1, {opacity:0, x:120}, {opacity:1, x:0, ease: Power2.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg91Anim.stop();\n        }\n      ",
    "searchText": "Gender Equality  Institutional  IN PURSUIT OF THE PERFECT BALANCE In 2021 the FIG continued its work towards gender equality in positions of governance in the sport of Gymnastics.  G  ymnastics is one of the rare Olympic sports that enjoys higher popularity among women than among men and under President Morinari Watanabe the FIG has striven to ensure that the gender balance in the sport’s governing bodies reflects this reality. Shortly after he became President, he established the FIG Women in Gymnastics Commission – later renamed the FIG Gender Equality Commission – and this has led to major changes in the FIG Statutes. In 2018, the FIG enshrined gender quotas in its Statutes for several elected positions with the purpose of encouraging more women to stand for leadership positions and so help the sport achieve a better balance between men and women in the decision-making process. The aim was to guarantee a minimum of 30% representation per gender for Vice-Presidents, Executive Committee members and Council members, as well  as the members of the Gymnastics for All Committee and the technical committees for Trampoline, Acrobatic and Aerobic Gymnastics. It was a move aligned with the IOC’s Olympic Agenda 2020, which included fostering gender equality among its recommendations, and was followed, in 2019, by the staging of the FIG Leadership Forum for Women. In 2021, the FIG implemented its new gender-quota mechanism for the first time in the elections which took place during the FIG Congress in Antalya, Turkey in November. The election results offered another sign of progress albeit this is an ongoing process and there are still further steps to take. “We all know that the ability to lead has nothing to do with gender,” said President Watanabe. “Both genders bring different approaches and ways of thinking that are valuable to any international organisation.”  “    Both genders bring different approaches and thinking.” Morinari Watanabe FIG President  30  % Minimum representation per gender, according to the FIG’s gender-quota mechanism  FIG YEARBOOK 2021  91"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 91,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg92.jpg",
    "zoom": null,
    "content": "\n      <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/Q2TK6djKfhc')\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:51px;top:746px\" src=\"/2021/static/_content/white-play.png\">\n      </a>\n\n      <div class=\"addContentLink\" style=\"top:198px;left:229px;width:58px;height:16px;\">\n        <a href=\"https://www.gymnastics.sport/site/education.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"  top: 294px; left: 255px; width: 143px; height: 11px;\">\n        <a href=\"https://www.youtube.com/channel/UCp49FtJ60tO3-ipVhlTstiw\" target=\"_blank\"></a>\n      </div>\n\n      <h1 id=\"92-no1\" class=\"abs merriweather-bold 92-no\" style=\"left: 474px; top: 196px; font-size: 2em; font-weight:300; margin:0; color:#e73b1f; padding:0; margin:0;\"  data-number='{\"to\": 8709, \"comma\": true}' ></h1>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg92Anim = new TimelineMax();\n          pg92Anim.fromTo(cOf(\"92-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"92-no\")[0]);}}, 1)\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1400);\n        }\n\n        function onPageLeave() {\n          pg92Anim.stop();\n          resetNumbers(\"92-no\")\n        }\n      ",
    "searchText": "Institutional  Development and Education  THE BEST OF BOTH WORLDS  The FIG continued to pursue new eLearning possibilities in 2021 while resuming its academy programme as the year drew to a close.  T  he FIG has created some innovative eLearning opportunities in response to the coronavirus pandemic and these activities gathered momentum in 2021. The governing body’s Education Commission staged its third online seminar series while also preparing the ground for a new online platform. If the pandemic meant a pause to the FIG’s usual coaching education endeavours – based around the Academies and age-group camps – this time was used to accelerate the push towards eLearning. This was a direction that the FIG had already been contemplating and now plans were made concrete and put into action. There were two initial seminar series held in 2020 before the Education Commission launched its  92  FIG YEARBOOK 2021  third series in February 2021, with one seminar per month until the end of the year. Every FIG seminar was pre-recorded and released on the FIG Education YouTube channel. To date this third series has attracted more than 20,000 views, while helping ensure an increase of more than 100% in registered users of the FIG’s Education YouTube channel. A central purpose of the FIG’s education work has always been to deliver knowledge to countries with no formal coaching education programmes and according to Marco Bortoleto, acting president of the Education Commission, these online seminars help to “increase the number of coaches served from all over the world”.  8,709 The seminar on ‘Dance steps in Rhythmic Gymnastics’ has earned almost 9,000 views  Below Foundations of Gymnastics course participants in Managua, Nicaragua"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 92,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg93.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:148px;left:258px;width:160px;height:29px;\">\n        <a href=\"https://www.youtube.com/channel/UCp49FtJ60tO3-ipVhlTstiw\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:177px;left:150px;width:205px;height:29px;\">\n        <a href=\"https://www.youtube.com/channel/UCp49FtJ60tO3-ipVhlTstiw\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Development and Education  Institutional  The 2021 online seminar series covered every discipline The Yurchenko preparation and development | Men’s Artistic Gymnastics  The genius solution to sport failure during competition | Psychology  The benefits of Gymnastics – Parts 1 and 2 | Generic  ACRO, more than a sport  Dance steps in Rhythmic Gymnastics Philosophy about the judgement in Parkour  The lost skill syndrome | Generic  What is Aerobic Gymnastics?  The coaching biomechanics interface | Generic Developing expressiveness in young athletes | Generic  Part method, a secure and fun way to learn Trampoline  FIG YEARBOOK 2021  93"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 93,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg94.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Institutional  Development and Education  “    The online seminars help to increase the number of coaches from all over the world.” Marco Bortoleto Acting president, Education Commission  The format and content of the seminars have evolved with each series, though one constant has been the wish to stage at least one seminar for every discipline. To this end, the Education Commission contacted the technical committee of every discipline to ask for suggested topics. This collaborative approach extended to consulting other internal commissions within the FIG along with national federations and continental unions. “We have eight different disciplines and we asked all responsible technical committees (GfA Committee) and commissions to bring some ideas or experts,” said Bortoleto. There have been adjustments made in response to feedback – for example,  94  FIG YEARBOOK 2021  while some of the early seminars in 2020 were over an hour long, they are now no longer than 45 minutes to better suit the online format. Additionally, there were seminars in the 2021 series which were more discussion-based – involving coaches, committee members and gymnasts – and focused on more general themes, such as the health and social benefits of the sport. Bortoleto explained: “In the first and second series we used the same format for all the seminars and now we have different ones – some are typical lectures; some are group discussions where we invite three people and have questions and discuss.”  Above left Teamwork for the Gymnastics for All course students in Managua, Nicaragua"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 94,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg95.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:424px;left:352px;width:61px;height:11px;\">\n        <a href=\"https://www.april6.org/2021/04/08/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"  top: 435px; left: 297px; width: 74px; height: 11px;\">\n        <a href=\"https://www.april6.org/2021/04/08/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:446px;left:297px;width:61px;height:11px;\">\n        <a href=\"https://www.april6.org/2021/04/08/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Looking ahead The FIG is committed to providing a broad range of education opportunities online. In 2021 it prepared an online platform, due to be available from early 2022, which will offer all the Level 1 theory lectures for the FIG Academy programme for every discipline. These will be for participants registered by their national federations. Also available will be a Foundations of Gymnastics course and a module on Safeguarding. The groundwork done by the Education Commission, working in close co-operation with the Education department of the FIG office, will allow many more people access to the Academy courses than before. It will also allow participants to complete the theoretical parts of the course online and thereby shorten the length of the in-person Academy courses from seven days to four in the case of the foundation courses and Level 1 Academies, and to six days for the Level 2 and 3 Academies, thus cutting the costs for coaches and federations alike. In the meantime, the current Academy programme resumed in late 2021 and included the first Parkour Academy in Asia – only the second for the discipline anywhere in the world. The Level 1 Academy took place from 14-20 November in Doha, Qatar and brought together participants from 14 different national federations. The Parkour community was also the beneficiary of the first age-group camp since the pandemic, held in Bogota, Colombia, from 15-19 December, with expert Francisco de la Riva Vasquez passing on his expertise to 39 coaches. The resumption of the FIG Academies was especially significant for bringing together the Gymnastics coaching community once more to exchange information in person. The Gymnastics for All course on the Foundations of Gymnastics – held in Managua, Nicaragua, from 3-10 October – was the first since the COVID-19 pandemic began, and the first FIG course staged in Nicaragua. Before the year ended, there were also Level 2 and Level 3 Artistic Gymnastics Academies in Tashkent, Uzbekistan, as well as a Rhythmic Gymnastics Level 3 Academy in Aracaju, Brazil.  International Day of Sport for Development and Peace To mark the International Day of Sport for Development and Peace in April 2021, the FIG website shone a light on the work of coaches in countries where Gymnastics is growing its profile – citing examples in Barbados, Benin and South Africa. Darius Fields (BAR), a Gymnastics coach and administrator, discussed his work developing Gymnastics in the Caribbean island nation of 280,000 people, including as coach of the Barbados national team. “People would say they want the World Championships and Olympics – my ambition is less that and more to see more engagement in the sport in the country,” said Fields who, as a boy, had learned to tumble on a Barbadian beach. There were reflections too from Innocent Yaka (BEN), deputy national technical director of the Beninese Gymnastics Federation, which celebrated 10 years in existence in 2021. He is a beneficiary of a six-month sports  management course through the University of Leipzig (GER) and promotes various disciplines in Benin, including Aerobic Gymnastics, with a threefold message: keeping a positive attitude, finding and maintaining the motivation to improve, and implementing healthy habits. Instilling core values about discipline and goal-setting are, similarly, part of the work of Offering Tlaka (RSA), the Trampoline and Tumbling chairman for Gymnastics South Africa, and head of the Klim-Gym Trampoline Club in Pretoria. As a gymnast he competed in World Championships and at The World Games in 2017 and he described how Gymnastics “opened my horizon to a totally different world, giving me the opportunity to study through my sport and giving me an opportunity to travel and meet people outside my culture and my religion”. A strong testimony of the transformative power of sport."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 95,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg96.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 96-text-1\" style=\"top:302px;right:216px;\" src=\"/2021/static/_content/96-text-1.png\">\n        <img class=\"halfScale 96-text-2\" style=\"top:207px;right:4px;\" src=\"/2021/static/_content/96-text-2.png\">\n        <img class=\"halfScale 96-text-3\" style=\"top:246px;right:440px;\" src=\"/2021/static/_content/96-text-3.png\">\n        <img class=\"halfScale 96-text-4\" style=\"top:164px;right:-117px;\" src=\"/2021/static/_content/96-text-4.png\">\n\n        <div class=\"addContentLink\" style=\"top:207px;left:186px;width:69px;height:12px;\">\n          <a href=\"https://www.gymnastics.sport/site/pages/education-academies.php\n          \" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg96Anim = new TimelineMax();\n          pg96Anim.fromTo(cOf(\"96-text-1\"), 1, {opacity:0, y:-60}, {opacity:1, y:0, ease: Power2.easeOut}, 1)\n          pg96Anim.fromTo(cOf(\"96-text-2\"), 1, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 1.3)\n          pg96Anim.fromTo(cOf(\"96-text-3\"), 1, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 1.6)\n          pg96Anim.fromTo(cOf(\"96-text-4\"), 1, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut, flashContentLinksThreeTimes}, 1.9)\n        }\n\n        function onPageLeave() {\n          pg96Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Institutional  Development and Education  FIG ACADEMIES BACK ON THE MAP The resumption in 2021 of the FIG Academies was significant for bringing together the global Gymnastics coaching community.  Rhythmic Gymnastics Level 3 Academy Acaraju (BRA), 13-19 December/ 11 participants, 9 national federations Experts Marta Bobo (ESP) Helena Dias (POR) Anita Klemann (BRA) Parkour Level 1 Academy Doha (QAT), 14-20 November/ 20 participants, 11 national federations  Artistic Gymnastics Level 2 Academy Tashkent (UZB), 21-28 November/ 22 participants, 9 national federations  Experts Charles Perriere (FRA) Chris Evans (GBR) Nicolas Fisher (SUI) Francisco Vazquez (BEL)  Experts Pedro Almeida (POR) Jacques Renson (BEL) Zsuzsanna Kalmar (HUN)  Gymnastics for All Foundations of Gymnastics course Managua (NCA), 3-10 October/ 25 participants, 6 national federations Experts Marco Bortoleto (BRA) Rogerio Valerio (POR) Carmen Gomez (MEX)  96  FIG YEARBOOK 2021  Artistic Gymnastics Level 3 Academy Tashkent (UZB), 13-19 December/ 9 participants, 6 national federations Experts Andrei Levit (POL) Konstantin Brodetskiy (KAZ) Mayya Filippova (UZB) Lourenço Franca (POR)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 96,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg97.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 97,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg98.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:521px;left:49px;width:449px;height:68px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/antidoping-about.php\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Institutional  Medical/Anti-Doping  EDUCATION BOLSTERS BID FOR CLEAN SPORT The International Testing Agency's #keepinggymnasticsreal campaign was part of the push to promote an anti-doping message in 2021.  T Athletes requesting an FIG licence must obtain the ITA InternationalLevel Athletes Education Programme certificate.  98  FIG YEARBOOK 2021  he FIG takes a zero-tolerance approach when it comes to anti-doping. To achieve this the FIG has worked closely with the International Testing Agency (ITA), first delegating part of its anti-doping programme to the ITA in 2019 and then updating this agreement in 2021. This has led to a comprehensive anti-doping programme for Gymnastics. A new phase began in 2021 in the form of the #keepinggymnasticsreal awareness campaign. “Keeping Sport Real” is the ITA motto and this was tweaked to incorporate  Gymnastics in a social-media campaign which showed images of gymnasts performing beside the catchline “Power of a Clean Routine”. “As far as anti-doping is concerned there is zero tolerance,” Nicolas Buompane, the FIG’s Secretary General, reiterated. “We want as the governing body for Gymnastics to fight against doping.” The year had begun with the World Anti-Doping Agency (WADA) releasing its Code for 2021 and its International Standards, which included a new International Standard for Education."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 98,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg99.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:57px;left:249px;width:321px;height:314px;\">\n        <a href=\"https://twitter.com/IntTestAgency/status/1471419612071972866\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:435px;left:482px;width:68px;height:24px;\">\n        <a href=\"https://ita.sport/partner/federation-internationale-de-gymnastique-fig/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Medical/Anti-Doping  Education is pivotal in the fight to keep sport clean and the #keepinggymnasticsreal campaign was not the only way of conveying the message as the ITA also held a webinar series to raise awareness about clean sport which ran through 2021. For its part, the FIG held a round table with the medical staff and delegation heads at each of the year’s five World Championships. The FIG’s Anti-doping, Medical & Scientific Commission (ADMSC) invited a member of WADA’s Education Commission to join Dr Yasunobu Iwasaki (JPN), the ADMSC President, at the round table at the Artistic Gymnastics World Championships in October. There is a representative of the ADMSC at every major FIG event, to ensure all regulations are met, and also to chair these round tables. One of either Dr Iwasaki (JPN), Dr Jay Binder (USA) or Dr Mariela Sirakova (BUL) was present at the World Championships. As well as the anti-doping message, other issues  discussed in 2021 included gender and mental health, and the latter felt ever more pertinent after the withdrawal of Simone Biles (USA) from most of her events at the Tokyo Olympic Games. Other education tools include the information booths set up in collaboration with the local National Anti-Doping Organisation (NADO) at all FIG World Championships to ensure both gymnasts and their coaches are fully informed – and to underline the message to gymnasts that they are responsible for what they put into their bodies. As well as working with the ITA, the FIG also co-operates on doping cases with the CAS Anti-Doping Division (CAS ADD).  ANTI-DOPING EDUCATION CERTIFICATES From February 2021, the FIG amended the certificates required for requesting athletes’ and coaches’ licences. This followed improvements made by WADA to its anti-doping education and learning platform (ADEL). Certificate mandatory for obtaining an Athletes’ licence: For any request of a first licence or a licence renewal, the FIG had previously asked that gymnasts complete the ALPHA programme but this was now updated to become  Institutional  The FIG has worked closely with the International Testing Agency  “    As far as anti-doping is concerned there is zero tolerance. We want to fight doping.” Nicolas Buompane FIG Secretary General  FIG YEARBOOK 2021  99"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 99,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg100.jpg",
    "zoom": null,
    "content": "\n      <h1 id=\"100-no1\" class=\"abs merriweather-bold 100-no\" style=\"left: 53px; top: 187px; font-size: 1.9em; font-weight:300; margin:0; color:#e73b1f; padding:0; margin:0;\"  data-number='{\"to\": 2}' ></h1>\n\n      <div class=\"addContentLink\" style=\"top:175px;left:439px;width:88px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/medical-covid19.php\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n            animateNumber(cOf(\"100-no\")[0])\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Institutional  Medical/Anti-Doping  2 Years that an International-Level Athletes Education Programme certificate is valid  Below Apparatus is disinfected during the Artistic Worlds in Kitakyushu, Japan  100  FIG YEARBOOK 2021  the International-Level Athletes Education Programme. Any athlete requesting an FIG licence or a renewal is obliged to complete this International-Level Athletes Education Programme and obtain the certificate, which must be uploaded to the athlete profile in the FIG database. The certificate is valid for two years, starting from the date of completion of the programme, and this means a new certificate must be provided for each licence renewal. Certificate mandatory for Coach participation: The ‘CoachTrue’ programme was renamed and became the HighPerformance Coaches' Education Programme. This is obligatory for any Gymnastics coaches who wish to attend an FIG event. First, they must already be registered in the FIG database and then they must complete this programme and obtain the certificate which is added to their coach profile in the database.  Steps to a safe environment The FIG provides Medical Guidelines for all of its events and in February 2021, ahead of the resumption of international Gymnastics competitions, a specific document was issued offering fresh guidelines for stakeholders, especially Local Organising Committees (LOCs), regarding medical considerations and risk-mitigation protocols in order to reduce the risks of spreading COVID-19 by providing a safe and secure environment for athletes and coaches."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 100,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg101.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Medical/Anti-Doping  Institutional  Tokyo reflections One aspect of the work of the Anti-doping, Medical & Scientific Commission is research. The commission president, Dr Yasunobu Iwasaki, attended the November 2021 meeting in Monaco for IOC International Federation and National Olympic Committee chairpersons, in order to present a paper titled 'An International Competition as the First Step to Tokyo 2020 – Challenges against the Public Opinion in Japan'. This paper was a reflection on the FIG Friendship and Solidarity Competition held in Japan in 2020.  FIG YEARBOOK 2021  101"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 101,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg102.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:292px;left:70px;width:132px;height:15px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/judges-support.php\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Institutional  Technology  PRECISION AT THE HEART OF JUDGING Fujitsu is working with the FIG on further developing the Judging Support System which is already in use on five apparatus in Artistic Gymnastics.  W  Above Fujitsu’s system comprises two functions: Multi-angle view and Automated D Score  102  FIG YEARBOOK 2021  ith the support of Fujitsu, a major and distinguished partner of the FIG, development is continuing on the platform to aid and improve judging. The Fujitsu Judging Support System (JSS) is a platform which leverages AI (artificial intelligence) and 3D-sensing technologies in order to conduct real-time movement capture which facilitates the analysis of elements and scoring of routines. The system was developed with the aim of making evaluation more accurate for all athletes, given the challenge that quick, complicated movements can sometimes pose for the naked eye. It is currently in official use in the event of blocked  scores or inquiries on five specific apparatus: the Pommel Horse, Still Rings and Vault in Men’s Artistic Gymnastics, and the Vault and Balance Beam in Women’s Artistic Gymnastics. Fujitsu’s system comprises two functions: Multi-angle View and Automated D Score. The Multiangle View allows for the Superior Jury to see the angles of all movements captured by a 3D sensor. This can be used to help judges reach agreement when assessing difficulty, as a video shows a skeletal model which measures many angles of a gymnast’s movement, which can be stopped and seen frame by frame."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 102,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg103.jpg",
    "zoom": null,
    "content": "\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/UsuWDvqozX8')\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:311px;top:179px\" src=\"/2021/static/_content/white-play.png\">\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Institutional  Technology  SUPPORT SYSTEMS The automated D score, currently in final development, generates the difficulty score and specific details captured by a 3D sensor. Testing has already begun with both JSS functions for men's Horizontal Bar and women's Uneven Bars. These features have evolved to reach this point from 2017 until now. The goal of the FIG and Fujitsu is to have this technological support available to evaluate difficulty on all 10 apparatus by 2024.  Technology is ever more important in the field of judging. Outside of Fujitsu, one strong example is the FIG’s Judge Evaluation Programme (JEP), which was used to select all the execution judges for the Tokyo 2020 Olympic Games. This is seen as a crucial tool for ensuring fairness as it is applied to the areas of Gymnastics which are judged subjectively – execution and artistry. It enables the FIG during and after competitions to measure the work of judges as far as execution is concerned. A control score is calculated and the judges are measured by their control score and then get an accuracy score and rating.  Another example is the FIG’s Judge online education programme (STS), which is a valuable interactive tool to help judges train ahead of courses and competitions. It promotes transparency by showing both judges and coaches how routines are being judged. The study materials include videos, practice quizzes and analysis, which are updated regularly, thereby allowing judges to stay up-to-date as the sport evolves, rather than simply studying for their brevet judges’ courses once every four years with some briefings at major competitions, as was previously the case.  FIG YEARBOOK 2021  103"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 103,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg104.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:199px;left:167px;width:145px;height:15px;\">\n        <a href=\"https://www.gymnastics.sport/site/apparatus/man_view.php\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Institutional  Apparatus  INNOVATIVE PLATFORM AIDS TESTING PROCESS The FIG gained a new online apparatus database in 2021 while implementing the Norms for the Runs and Obstacles of Parkour.  F  or the certification of all Gymnastics apparatus, the FIG works closely with GymLab, a testing institute in Freiburg, Germany, and the Tokyo Institute of Technology in Tokyo, Japan. In 2021, it completed a significant innovation to smooth the process of certifying equipment – namely, the creation of an Online Apparatus database. This platform, which has secured-access regulation, covers all areas of apparatus certification. For the FIG and its two test institutes,  104  FIG YEARBOOK 2021  it offers a library of all Gymnastics equipment – be it approved and certified or in the process of being tested. Manufacturers can use the platform to apply for the certification of their equipment; they can subsequently log in and keep track of the progress of their application."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 104,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg105.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"105-no\" class=\"abs merriweather-bold 105-no\" style=\"top: 559px; left: 63px; font-size: 2em; font-weight: 300; color: #FFFFFF; padding: 0px; margin: 0px;\"  data-number='{\"to\": 290, \"comma\": true}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg105Anim = new TimelineMax();\n          pg105Anim\n            .fromTo(cOf(\"105-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"105-no\")[0])}}, 1)\n        }\n\n        function onPageLeave() {\n          pg105Anim.stop();\n          resetNumbers(\"105-no\");\n          removeContentLinks();\n          removeContentLinksThree();\n        }\n      ",
    "searchText": "Apparatus  Institutional  Below The Field of Play at Parkour’s Sofia World Cup  290 The height in centimetres the Rings will be raised to  For the test institutes, similarly, the database serves as a place to log and monitor the flow of equipment received for assessment and approval. As well as certifying new equipment, the FIG continues to evaluate, adapt and, if necessary, modify the Apparatus Norms in the interest of athlete safety. To this end, the FIG Executive Committee approved an increase to the height of the Uneven Bars and the Rings following requests from both the Men’s and Women’s Artistic Gymnastics Technical Committees. For Uneven Bars, this means both bars will be raised by 5cm to 175/255cm with taller gymnasts permitted to request an additional 5cm. For Rings, these will be raised by 10cm to 290cm and a 10cm supplementary mat added (2x4m). This soft foam mat, placed on top of  the landing surface, ensures a safer landing, though taller gymnasts can remove it by request. These changes were initially due to become valid from January 2021 but, owing to the Olympic Games, this was postponed for a year. Another noteworthy development in Artistic Gymnastics was the certification of a new device to control the tension of the apparatus cables – such as the chains on the High Bar which ensure the apparatus stands vertically. The device allows coaches to check the tension in the chains and the FIG discussed its possible future application, both for safety reasons and also to help guarantee the same tension in the training hall, warm-up hall and Field of Play.  FIG YEARBOOK 2021  105"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 105,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg106.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 106-icon\" style=\"top:258px;right:189px;\" src=\"/2021/static/_content/106-icon-1.png\">\n        <img class=\"halfScale 106-icon\" style=\"top:324px;right:189px;\" src=\"/2021/static/_content/106-icon-2.png\">\n        <img class=\"halfScale 106-icon\" style=\"top:390px;right:189px;\" src=\"/2021/static/_content/106-icon-3.png\">\n        <img class=\"halfScale 106-icon\" style=\"top:456px;right:189px;\" src=\"/2021/static/_content/106-icon-4.png\">\n        <img class=\"halfScale 106-icon\" style=\"top:522px;right:189px;\" src=\"/2021/static/_content/106-icon-5.png\">\n\n        <div class=\"addContentLink\" style=\"top:185px;left:349px;width:92px;height:12px;\">\n          <a href=\"https://www.gymnastics.sport/site/apparatus/man_view.php\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg106Anim = new TimelineMax();\n          pg106Anim.staggerFromTo(cOf(\"106-icon\"), 1, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: flashContentLinksThreeTimes}, 0.2, 1)\n        }\n\n        function onPageLeave() {\n          pg106Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Institutional  Apparatus  The biggest change made to the Apparatus Norms in 2021 concerned Parkour. Since these norms were created in 2018, there have been amendments to the testing procedures and, in 2021, the FIG confirmed the dimension and shape of the Field of Play while at the same time giving event organisers the possibility to adapt the shape to their needs. There were also clarifications made to elements concerning safety – such as free-falling height or low-landing area descriptions – and the choice of colours. In Trampoline, there were discussions and a subsequent decision made to permit more than one type of safety mat. Where previously event organisers could use only one type of foam for the safety mats around trampolines in training, warm-up and the competition areas, now they have the option of using two types. The conditions are: a) the mats must come from the same manufacturer and b) they cannot be mixed in the same area, i.e., one type of mat can be used for training and warm-up and another in the Field of Play, but not interspersed. Additionally, the Executive Committee approved new specifications for the safety padding used in Trampoline in order to allow new materials that significantly increase the energy-absorption capabilities of the equipment Finally, following requests from coaches from across the world and discussions with manufacturers, the Trampoline Technical Committee moved in 2021 to alter the weight and dimensions of spotter mats. These mats, used by coaches to break a gymnast’s fall, have previously had no weight restrictions and this has led to instances where smaller coaches had problems lifting and throwing them. The new dimensions forwarded to the Executive Committee for approval include a maximum weight of 8.5kg.  106  FIG YEARBOOK 2021  A new database Developed by the FIG Office and FIG Test Institute in Freiburg, this online platform will provide a list of approved and certified apparatus. It will show the real-time status of apparatus in the certification process and facilitate this process, as outlined by the FIG’s Apparatus Norms:  1  Manufacturer has to register apparatus on the database and create a request on the FIG apparatus platform  2 FIG approval of request  3  Testing at one of the FIG-recognised Testing Institutes  4 Practical test  5 Issuing of the certificate by the FIG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 106,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg107.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:841px;left:457px;width:68px;height:15px;\">\n        <a href=\"mailto:intl-1@senoh.co.jp\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 107,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg108.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:423px;left:140px;width:21px;height:12px;\" onclick=\"Publish.goToPage(84)\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Institutional  Financial  CHALLENGING TIMES A prudent approach has allowed the FIG to sustain its investment in the sport despite the pandemic.  A  s with all sporting federations, the FIG saw its activities heavily impacted by the pandemic and the postponement of some events – shifted from 2020 into 2021 – and the cancellation of others had financial consequences. Nevertheless, thanks to a prudent financial strategy aimed towards the long term, it has been possible to continue providing support to athletes and member federation as well as to sustain investment in programmes and new technologies. As mentioned on p84, the FIG in collaboration with the FIG Foundation for Solidarity set up a Solidarity COVID-19 fund to the amount of CHF 300,000 and cancelled the annual membership fee in order to support athletes and member federations during these difficult times.  PROFIT & LOSS STATEMENT 2021 (IN THOUSANDS OF SWISS FRANCS)  108  Budget  Actual  EVENTS + Non-core activities RESULT  12,604  18,775  OPERATIONAL EXPENSES  -10,202  -8,155  OPERATING RESULT  2,402  10,620  FINANCIAL RESULT  20  1,848  BUILDING RENTAL RESULT  405  404  EXCEPTIONAL ITEMS RESULT  -2,852  -2,663  NET RESULT  -25  10,209  FIG YEARBOOK 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 108,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg109.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:283px;left:284px;width:170px;height:15px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/governance-financial.php\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Financial  Institutional  FINANCIAL INVESTMENTS ALLOCATION (AT 31 DECEMBER 2021) The FIG Executive Committee has defined a defensive investment strategy designed to protect the organisation's assets whilst benefitting from low-risk growth opportunities. The FIG's investments have been managed by financial institutions according to the mentioned strategy. The FIG's management and the FIG Auditors monitor the investment performance and report to the Executive Committee on a regular basis. Refer to the 2021 FIG Financial Report online.  Commodities  5%  Alternative  5%  Equities 40%  Bonds 45%  Cash 0%  min  target  5%  10%  20%  max  30%  Actual  40%  50%  60%  70%  80%  Target  Higher sponsorship income Prior years’ broadcasting income Due to reduced or cancelled competitions, there were fewer expenses  Lower meeting expenses due to cancellations and videoconferencing F  und allocation for Continental Unions' development activities has been maintained Lower expenses due to cancelled educational courses  Unrealised profit (mostly on financial investments) contributed to the outstanding positive financial result  Impact (as budgeted) for shifted events from 2020  FIG YEARBOOK 2021  109"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 109,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg110.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Institutional  Financial  BALANCE SHEET AT 31 DECEMBER 2021 (IN THOUSANDS OF SWISS FRANCS)  52,231  Current assets  15,723  Current liabilities  21,614  Non-current liabilities 35,568  20,674  Reserves  Non-current assets  TOTAL 72,905  TOTAL 37,337  ASSETS  LIABILITIES AND RESERVES  TOTAL 35,568  NOTES • Current assets are split into cash and cash equivalent funds of CHF 32,426 financial investments of CHF 25,306 (recognised at their market value at year-end date) less a provision for potential future value adjustment of CHF 6,801 other current assets of CHF 1,300. The substantial amount of cash funds is mainly related to the revenue share received for the Tokyo 2020 Olympic Games and will be used over a four-year-period. • Non-current assets (fixed assets) are stated at their acquisition cost less the accumulated depreciation calculated over their lifetime.  110  FIG YEARBOOK 2021  • Current liabilities refer to short-term liabilities (until 31 December 2022) including pre-invoiced income and deposits for events. • Non-current liabilities reflect long-term (from 1 January 2023) liabilities such as pre-invoiced income and deposits for events as well as dedicated provisions for programmes and projects.  • Reserves result from the accumulated profits carried forward and are a vital element to guarantee continuous support and development of our activities. Reserves are subject to fluctuation."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 110,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg111.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Financial  Institutional  RESERVES 2017-2024  (IN MILLIONS OF SWISS FRANCS) A stable financial situation  21.9  2017  22.9  2018  35.6  26.0  25.4  2019  2020  33.7  32.1 26.3  2021  2022  2023  2024  Monetary assets and liabilities in foreign currency are converted according to the exchange rate in force on the closing date of the financial year.  FIG YEARBOOK 2021  111"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 111,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg112.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:845px;left:459px;width:140px;height:15px;\">\n        <a href=\"https://www.spieth-gymnastics.com\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "REACH THE MAXIMUM since 1831  Official Supplier 2022: World Championships ACRO: Baku (AZE) European Championships RG: Tel Aviv (ISR) European Championships AG: Munich (GER) World Championships RG: Sofia (BUL)  Simone Biles, Artistic Gymnastics World Championships Stuttgart 2019  Explore the catalog! www.spieth-gymnastics.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 112,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg113.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:785px;left:109px;width:420px;height:35px;\">\n        <a href=\"https://www.taishansports.cn\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 113,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg114.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 114,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg115.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Inside the Highlights  of 2021  FIG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 115,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg116.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 116-line\" style=\"top:695px;left:312px;\" src=\"/2021/static/_content/116-line-1.png\">\n        <img class=\"halfScale 116-line\" style=\"top:673px;left:312px;\" src=\"/2021/static/_content/116-line-2.png\">\n        <img class=\"halfScale 116-line\" style=\"top:651px;left:312px;\" src=\"/2021/static/_content/116-line-3.png\">\n        <img class=\"halfScale 116-line\" style=\"top:629px;left:312px;\" src=\"/2021/static/_content/116-line-4.png\">\n        <img class=\"halfScale 116-line\" style=\"top:607px;left:312px;\" src=\"/2021/static/_content/116-line-5.png\">\n        <img class=\"halfScale 116-line\" style=\"top:585px;left:312px;\" src=\"/2021/static/_content/116-line-6.png\">\n\n        <img class=\"halfScale 116-text\" style=\"top:739px;left:281px;\" src=\"/2021/static/_content/116-text-1.png\">\n        <img class=\"halfScale 116-text\" style=\"top:755px;left:147px;\" src=\"/2021/static/_content/116-line-7.png\">\n        <img class=\"halfScale 116-text\" style=\"top:773px;left:81px;\" src=\"/2021/static/_content/116-text-2.png\">\n        <img class=\"halfScale 116-text\" style=\"top:773px;left:273px;\" src=\"/2021/static/_content/116-text-3.png\">\n        <img class=\"halfScale 116-text\" style=\"top:773px;left:424px;\" src=\"/2021/static/_content/116-text-4.png\">\n\n        <div class=\"addContentLink\" style=\"top:137px;left:378px;width:59px;height:18px;\">\n          <a href=\"https://www.gymnastics.sport/site/pages/about-congress.php\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg116Anim = new TimelineMax();\n          pg116Anim.staggerFromTo(cOf(\"116-line\"), 1, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, 1)\n          pg116Anim.staggerFromTo(cOf(\"116-text\"), 1, {opacity:0, y:60}, {opacity:1, y:0, ease: Power2.easeOut, onComplete: flashContentLinksThreeTimes}, 0.2, 2.4)\n        }\n\n        function onPageLeave() {\n          pg116Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Inside the FIG  Structure of the Organisation  ROLES AND BODIES EXPLAINED  CONGRESS  From its base in Lausanne, Gymnastics’ world governing body oversees eight different disciplines under the leadership of President Morinari Watanabe.  T  he International Gymnastics Federation (FIG) is the governing body for Gymnastics worldwide. It is the oldest established international federation of an Olympic sport and has participated in the Olympic Games since their revival in 1896. The FIG governs eight sports: Gymnastics for All Men's and Women’s Artistic Gymnastics Rhythmic Gymnastics Trampoline, including Double Mini-trampoline and Tumbling Aerobics Acrobatics and Parkour. It counts 156 national member federations and has its headquarters in the Olympic capital of Lausanne (SUI).  According to the FIG Statutes, the Congress is the highest regulatory and supreme authority of the FIG. It is the biennial general assembly of the delegates of the affiliated member federations and takes place in even years. As the legislative body of world Gymnastics, the Congress bears a particular responsibility for developing the sport. Among its main responsibilities are: •T  o deal with financial matters, including the approval of the quadrennial financial plan and adoption of financial statements for the preceding two years •T  o consider admissions and expulsions of federations •T  o carry out elections of the FIG Authorities every four years, including the President, the three Vice-Presidents, the seven members of the Executive Committee, the six Technical Presidents, the President of the Gymnastics for All Committee and two Auditors  Congress Structure President Three Vice-Presidents Presidential Commission Executive Committee General assembly of the affiliated national federations  Council National federations  Responsibilities Financial Matters - Approval of quadrennial plan - Adoption of statements for preceding two years  116  FIG YEARBOOK 2021  Admissions - Including expulsions of national federations  Elections - To carry out elections of FIG Authorities every four years"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 116,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg117.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:530px;left:62px;width:48px;height:19px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/about-council.php\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Structure of the Organisation  COUNCIL The Council is the second-highest authority of the FIG. It is the annual legislative assembly of 45 delegates from five continents. The FIG Council is an important decision-making body. It notably falls to the Council to allocate the World Championships, the World Gymnaestrada and the World Gym for Life Challenge and to revise the Technical Regulations and the Gymnastics for All rules and regulations. The Council also considers the President’s Report, ratifies the acts of the Executive Committee, approves the annual financial reports including budget, can grant provisional membership of national federations, adopts and revises the Code of Discipline, and ensures that the decisions of Congress, and of any Extraordinary Congress, are properly implemented.  Inside the FIG  The Council is composed of: • The FIG President, the three FIG Vice-Presidents and the seven elected members of the Executive Committee • 21 Council members elected during the Congress by the Continental Unions • The six Technical Committee Presidents and the President of the Gymnastics for All Committee • The five Presidents of the Continental Unions • The President of the Athletes' Commission  FIG YEARBOOK 2021  117"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 117,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg118.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:434px;left:52px;width:120px;height:19px;\">\n      <a href=\"https://www.gymnastics.sport/site/pages/about-ec.php\" target=\"_blank\"></a>\n      </div>\n      \n      <div class=\"addContentLink\" style=\"top:434px;left:237px;width:128px;height:19px;\">\n      <a href=\"https://www.gymnastics.sport/site/pages/about-technical.php\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Inside the FIG  Structure of the Organisation  EXECUTIVE COMMITTEE  TECHNICAL COMMITTEES  According to the FIG Statutes, the Executive Committee has the responsibility, under the general direction and authority of the Council, for the administration and financial management of the FIG.  The six elected Technical Committees and the nominated Parkour Commission are responsible for managing their disciplines within the FIG (Men’s Artistic Gymnastics, Women’s Artistic Gymnastics, Rhythmic Gymnastics, Trampoline Gymnastics, Acrobatic Gymnastics, Aerobic Gymnastics, and Parkour). The GfA Committee is responsible for Gymnastics for All matters. The Technical Committees are made of one President and six other members (including the Vice-Presidents), elected by the Congress. The representative of the Athletes’ Commission of the said discipline (except for the GfA Committee) serves on the respective Technical Committee.  The Executive Committee is composed of 24 members: • The President • The three Vice-Presidents • Seven other elected members • The six Presidents of the Technical Committees and the President of the Gymnastics for All Committee • The President of the Athletes' Commission • The five Presidents of the Continental Unions The Executive Committee must meet at least twice annually, in addition to the meeting held in conjunction with the Congress, but it usually holds a meeting each trimester.  118  FIG YEARBOOK 2021  Above The entrance to the FIG's Headquarters in Lausanne, Switzerland"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 118,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg119.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:46px;left:158px;width:281px;height:29px;\">\n        <a href=\"https://www.venturelli.com\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 119,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg120.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:265px;left:95px;width:121px;height:15px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/athletesCommission.php\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Inside the FIG  Athletes' Commission  THE VOICE OF THE GYMNASTS  3  4  The FIG Athletes’ Commission plays a crucial role in promoting the priorities of gymnasts in the sport’s governance and 2021 saw a new commission take shape for 2022-25.  I  n the face of the ongoing challenges brought by the pandemic, the FIG Athletes’ Commission has continued its important work for gymnasts around the world. Meetings were held online throughout 2021 and, through various communication channels including social networks, the Athletes’ Commission succeeding in maintaining a constant flow of information. With new communication platforms available, and more people using them following the pandemic, members were able to communicate with the broader community and engage in open, productive discussions. The Athletes’ Commission received feedback and recommendations from gymnasts, and these were presented to the FIG Executive Committee, Technical Committees and sports department. In preparing the new Code of Points, the Technical Committees took into consideration gymnasts’ feedback and proposals. The Athletes' Representatives received several proposals, some of which contributed for example to the discussion regarding the Olympic Qualification system. The main priority has been to develop a qualification system that is easy to understand and track, both for those in the community and the media. Lastly, to enhance communication within the athlete community, as well as with the sport’s governing bodies, there is strong support for the creation of Continental Athletes’ Commissions.  120  FIG YEARBOOK 2021  Aljaz Pegan (SLO) President of the new FIG Athletes’ Commission “From my first term as Athletes’ Representative for Men’s Artistic Gymnastics, I know that being in personal contact with athletes is crucial, even when the situation is difficult, as it has been for two years. My goal is to promote the Athletes’ Commission at continental level, to encourage the setting up of Athletes’ Commissions on every continent, and also at national federation level. Athletes’ Representatives are important for spreading decisions and policies and making the athletes’ voices heard.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 120,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg121.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Athletes' Commission  Inside the FIG  The Athletes’ Commission  6  One member per discipline 1  2  2 1 3  4  5  6  7  5  The Athletes’ Commission is composed of seven members – one representative for each competitive discipline – and elections in each discipline usually take place every four years during the World Championships. In 2021, there were elections for the Athletes' Representatives in six disciplines. In Women’s Artistic Gymnastics, three-time Olympic champion Catalina Ponor (ROU) was elected and will continue the work of eight-time Olympian Oksana Chusovitina (UZB). In Trampoline, the 2012 and 2016 Olympic champion Rosannagh MacLennan (CAN) succeeded Nuno Merino (POR), who had completed the maximum two-term representation role. In Rhythmic Gymnastics, five-time World Championships competitor  Aljaz Pegan (SLO) Men’s Artistic Gymnastics Catalina Ponor (ROU) Women’s Artistic Gymnastics Siyana Vasileva (AZE) Rhythmic Gymnastics Rosannagh MacLennan (CAN) Trampoline Gymnastics May Miller (ISR) Acrobatic Gymnastics Dora Hegyi (HUN) Aerobic Gymnastics Micaela Buono Pugh (ARG) Parkour  7  Siyana Vasileva (AZE) replaced Liubov Charkashyna (BLR), who had served as President of the Athletes’ Commission since 2017 and was elected to the RG Technical Committee at the Congress in November. These new members joined re-elected members Dora Hegyi (HUN, Aerobic Gymnastics), May Miller (ISR, Acrobatic Gymnastics) and Aljaz Pegan (SLO, Men’s Artistic Gymnastics), and completing the group is Micaela Buono Pugh (ARG, Parkour), whose term will run until the election at the first World Championships.  1999 The year that the Athletes’ Commission was founded  FIG YEARBOOK 2021  121"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 121,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg122.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 122,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg123.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Outlook 2022-24"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 123,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg124.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Outlook 2022-2024  BUILDING FOR TOMORROW TODAY The FIG’s aims for the 2022-24 cycle include developing Gymnastics on every continent, embracing technology and making a positive contribution to society.  124  FIG YEARBOOK 2021"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 124,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg125.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:694px;left:249px;width:72px;height:17px;\">\n        <a href=\"https://www.gymnastics.sport/site/governance.php\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Outlook 2022-2024  S  trengthening governance, encouraging digital transformation and emphasising values of solidarity and equity. All are priorities for Morinari Watanabe in his second term as FIG President. “Recent years show that people now expect sporting events not only to be entertaining, but also to act as vectors of social change towards a better society,” said President Watanabe. “There has been a huge shift in the importance of values, and we must embrace this trend in favour of more solidarity, equity and friendship. In this respect, the focus should be not only on elite athletes  and children, but on everyone – especially older people.” The President’s goals and objectives are focused on several key pillars:  GOVERNANCE One of the main priorities is to uphold ethics in all Gymnastics member federations and thus to demonstrate a high standard of governance at all levels. This pillar rests on an overhaul of the FIG Statutes that has to be approved at the 2022 Congress and a reform of the electoral system to be planned by a working group.  Gymnastics for All  FIG YEARBOOK 2021  125"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 125,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg126.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Outlook 2022-2024  Solidarity is part of the FIG mission.  DIGITAL TRANSFORMATION  Above Gymnastics for All  126  FIG YEARBOOK 2021  Embracing cutting-edge technology for events, FIG operations and relationships with national federations is another main priority, especially since the COVID-19 pandemic has accelerated the need for digital platforms and communication tools right across society. Other areas of innovation include the FIG’s new elearning platform, and a search for new formats to increase the value of Gymnastics competitions.  SUSTAINABLE DEVELOPMENT GOALS (SDGS) President Watanabe believes that Gymnastics can contribute effectively to three of the United Nations’ SDGs: people’s Health (SDG 3), Gender equality (SDG 5) and Peace (SDG 16). It can help and encourage older people to remain healthy, thereby reducing medical costs. It can also bring men and women together, encouraging gender equality. Solidarity is another part of the FIG mission for this next cycle and this includes identifying problems and proposing solutions for federations in new or developing nations."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 126,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg127.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 127-box-1\" style=\"top:162px;left:55px;\" src=\"/2021/static/_content/127-box-1.png\">\n        <img class=\"halfScale 127-box-2\" style=\"top:67px;left:328px;\" src=\"/2021/static/_content/127-box-2.png\">\n        <img class=\"halfScale 127-box-3\" style=\"top:240px;left:399px;\" src=\"/2021/static/_content/127-box-3.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg127Anim = new TimelineMax();\n          pg127Anim.staggerFromTo(cOf(\"127-box-1\"), 1, {opacity:0, x:-60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, 1)\n          pg127Anim.staggerFromTo(cOf(\"127-box-2\"), 1, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, 1.3)\n          pg127Anim.staggerFromTo(cOf(\"127-box-3\"), 1, {opacity:0, x:60}, {opacity:1, x:0, ease: Power2.easeOut}, 0.2, 1.6)\n        }\n\n        function onPageLeave() {\n          pg127Anim.stop();\n        }\n      ",
    "searchText": "Outlook 2022-2024"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 127,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg128.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Gymnastics for All"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 128,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg129.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:240px;left:63px;width:47px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/about-president.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:251px;left:63px;width:47px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/about-congress.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:262px;left:63px;width:38px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/about-council.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:272px;left:63px;width:99px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/about-ec.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:283px;left:63px;width:103px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/about-technical.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:294px;left:63px;width:103px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/athletesCommission.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:359px;left:63px;width:43px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/rules/\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:370px;left:63px;width:56px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/governance.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:381px;left:63px;width:139px;height:11px;\">\n        <a href=\"https://www.gymnasticsethicsfoundation.org/\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:391px;left:63px;width:115px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/about-foundation.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:402px;left:63px;width:63px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/safeguarding.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:413px;left:63px;width:49px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/education.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:424px;left:63px;width:144px;height:11px;\">\n        <a href=\"https://www.youtube.com/channel/UCp49FtJ60tO3-ipVhlTstiw\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:435px;left:63px;width:58px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/antidoping-about.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:446px;left:63px;width:133px;height:11px;\">\n        <a href=\"https://ita.sport/partner/federation-internationale-de-gymnastique-fig/\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:457px;left:63px;width:175px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/judges-support.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:468px;left:63px;width:95px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/apparatus/man_view.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:478px;left:63px;width:39px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/governance-financial.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:489px;left:63px;width:56px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/pages/bulletins.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:554px;left:63px;width:139px;height:11px;\">\n        <a href=\"https://live.fig-gymnastics.com/news.php?idevent=15571\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:565px;left:63px;width:91px;height:11px;\">\n        <a href=\"https://live.fig-gymnastics.com/schedule.php?idevent=15571\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:576px;left:63px;width:111px;height:11px;\">\n        <a href=\"https://live.fig-gymnastics.com/medals.php?idevent=15571\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:587px;left:63px;width:232px;height:11px;\">\n        <a href=\"https://live.fig-gymnastics.com/news.php?idevent=16634\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:598px;left:63px;width:242px;height:11px;\">\n        <a href=\"https://live.fig-gymnastics.com/news.php?idevent=16637\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:609px;left:63px;width:248px;height:11px;\">\n        <a href=\"https://live.fig-gymnastics.com/news.php?idevent=16136\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:619px;left:63px;width:242px;height:11px;\">\n        <a href=\"https://live.fig-gymnastics.com/news.php?idevent=16527\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:630px;left:63px;width:232px;height:11px;\">\n        <a href=\"https://live.fig-gymnastics.com/news.php?idevent=16548\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:641px;left:63px;width:180px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/rankings/archives.php\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:652px;left:63px;width:72px;height:11px;\">\n        <a href=\"https://www.gymnastics.sport/site/events/search.php?type=sport\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:714px;left:63px;width:70px;height:17px;\">\n        <a href=\"https://www.facebook.com/fig.gym\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:735px;left:63px;width:70px;height:17px;\">\n        <a href=\"https://www.instagram.com/figymnastics/\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:757px;left:63px;width:61px;height:17px;\">\n        <a href=\"https://twitter.com/gymnastics\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:779px;left:63px;width:61px;height:17px;\">\n        <a href=\"https://www.youtube.com/gymnasticschannel\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Useful Links  USEFUL LINKS ABOUT THE FIG President Congress Council Executive Committee Technical Committees Athletes' Commission  INSTITUTIONAL Statutes Governance Gymnastics Ethics Foundation Foundation for Solidarity Safeguarding Education FIG Education YouTube Channel Anti-Doping International Testing Agency Technology – Judging Support System Apparatus Database Finance FIG Bulletin  SPORT		 Tokyo 2020 FIG Event Website Tokyo 2020 Results Tokyo 2020 Medal Table 50th FIG Artistic Gymnastics World Championships 38th FIG Rhythmic Gymnastics World Championships 35th FIG Trampoline Gymnastics World Championships 27th FIG Acrobatic Gymnastics World Championships 16th FIG Aerobic Gymnastics World Championships World Ranking Archives (all disciplines) Event Calendar  SOCIAL MEDIA Facebook Instagram Twitter YouTube  FIG YEARBOOK 2021  129"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 129,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg130.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Official Partners  The FIG is proud to present its Official Partners, who not only support the                                           disciplines.                                                                             "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 130,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg131.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:329px;left:39px;width:150px;height:14px;\">\n        <a href=\"https://www.ebu.ch/eurovision-sport\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 131,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg132.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:839px;left:438px;width:120px;height:14px;\">\n        <a href=\"https://www.gymnastics.sport\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            flashContentLinksThreeTimes();\n          }, 1000);\n        }\n  \n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "www.gymnastics.sport"
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n\n      function flashContentLinksThreeTimes() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-198877654-3',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NZMO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OOSv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SCeq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eJtY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e347990d770f9d051c48.js